// PLANTS ALLIUMS
// Clean database with regional names support

import { PlantData } from './plants-master-database'

export const alliumsData: PlantData[] = [
  {
    id: 'garlic-hardneck',
    name: 'Garlic - Hardneck',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato'],
    enemies: ['bean', 'pea'],
    description: 'Cold hardy garlic with stiff central stalk. Scapes in spring.',
    hardinessZones: '3-8',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Music', 'German White', 'Chesnok Red'],
    uses: ['cooking', 'scapes', 'storage']
  },
  {
    id: 'garlic-softneck',
    name: 'Garlic - Softneck',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 240,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato'],
    enemies: ['bean'],
    description: 'Milder flavor, longer storage. No scapes, braided tops.',
    hardinessZones: '5-10',
    plantingSeason: 'fall',
    height: '12-18 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Inchelium Red', 'California Early'],
    uses: ['cooking', 'braiding', 'storage']
  },
  {
    id: 'onion-red',
    name: 'Onion - Red',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 95,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce'],
    enemies: ['bean', 'pea'],
    description: 'Sweet red onions for salads and sandwiches. Short storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Red Wing', 'Red Burgundy'],
    uses: ['salads', 'sandwiches', 'fresh']
  },
  {
    id: 'onion-white',
    name: 'Onion - White',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot'],
    enemies: ['bean'],
    description: 'Mild white onions for fresh eating and Mexican cuisine.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['White Sweet Spanish', 'Southport White'],
    uses: ['fresh', 'salsa', 'cooking']
  },
  {
    id: 'leek-american-flag',
    name: 'Leek - American Flag',
    scientificName: 'Allium ampeloprasum',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 130,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'celery'],
    enemies: ['bean'],
    description: 'Long white stems with blue-green flags. Very cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '2-3 inches',
    family: 'Amaryllidaceae',
    varieties: ['American Flag', 'King Richard'],
    uses: ['soup', 'cooking', 'braising']
  },
  {
    id: 'shallot-french',
    name: 'Shallot - French',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot'],
    enemies: ['bean'],
    description: 'Mild onion-garlic flavor, clustered bulbs. Gourmet cooking.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['French Gray', 'Dutch Yellow'],
    uses: ['cooking', 'vinaigrette', 'fine dining']
  },
  {
    id: 'green-onion-bunching',
    name: 'Green Onion - Bunching',
    scientificName: 'Allium fistulosum',
    category: 'allium',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce'],
    enemies: ['bean'],
    description: 'Perennial bunching onions, no bulb. Scallions all season.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '1-2 inches',
    family: 'Amaryllidaceae',
    varieties: ['Evergreen Hardy White', 'Ishikura'],
    uses: ['salads', 'garnish', 'cooking']
  },
  {
    id: 'elephant-garlic',
    name: 'Elephant Garlic',
    scientificName: 'Allium ampeloprasum',
    category: 'allium',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 240,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose'],
    enemies: ['bean'],
    description: 'Large mild garlic-like bulbs, closer to leeks. Impressive size.',
    hardinessZones: '3-10',
    plantingSeason: 'fall',
    height: '24-36 inches',
    spread: '6-8 inches',
    family: 'Amaryllidaceae',
    varieties: ['Elephant', 'Russian Giant'],
    uses: ['roasting', 'cooking', 'mild garlic']
  }
,
  {
    id: 'onion-walla-walla',
    name: 'Onion - Walla Walla',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'yellow onion. short-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Walla Walla'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-sweet-spanish',
    name: 'Onion - Sweet Spanish',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'red onion. intermediate-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Sweet Spanish'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-red-burgundy',
    name: 'Onion - Red Burgundy',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'white onion. long-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Red Burgundy'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-yellow-sweet-spanish',
    name: 'Onion - Yellow Sweet Spanish',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'sweet onion. short-day variety. Mild and sweet, perfect for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Yellow Sweet Spanish'],
    uses: ['fresh', 'salads', 'burgers']
  },
  {
    id: 'onion-texas-grano',
    name: 'Onion - Texas Grano',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'storage onion. intermediate-day variety. Pungent and long-keeping.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Texas Grano'],
    uses: ['cooking', 'storage', 'caramelizing']
  },
  {
    id: 'onion-vidalia',
    name: 'Onion - Vidalia',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 3,
    rowSpacing: 8,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'bunching onion. long-day variety. Harvest young as green onions.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '2-3 inches',
    family: 'Amaryllidaceae',
    varieties: ['Vidalia'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-maui',
    name: 'Onion - Maui',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 3,
    rowSpacing: 8,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'shallot onion. short-day variety. Mild gourmet flavor, clustered bulbs.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '2-3 inches',
    family: 'Amaryllidaceae',
    varieties: ['Maui'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-walla-walla-sweet',
    name: 'Onion - Walla Walla Sweet',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'yellow onion. intermediate-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Walla Walla Sweet'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-candy',
    name: 'Onion - Candy',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'red onion. long-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Candy'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-super-star',
    name: 'Onion - Super Star',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'white onion. short-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Super Star'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-red-zeppelin',
    name: 'Onion - Red Zeppelin',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'sweet onion. intermediate-day variety. Mild and sweet, perfect for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Red Zeppelin'],
    uses: ['fresh', 'salads', 'burgers']
  },
  {
    id: 'onion-ringmaster',
    name: 'Onion - Ringmaster',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'storage onion. long-day variety. Pungent and long-keeping.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Ringmaster'],
    uses: ['cooking', 'storage', 'caramelizing']
  },
  {
    id: 'onion-yellow-granex',
    name: 'Onion - Yellow Granex',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 3,
    rowSpacing: 8,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'bunching onion. short-day variety. Harvest young as green onions.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '2-3 inches',
    family: 'Amaryllidaceae',
    varieties: ['Yellow Granex'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-red-creole',
    name: 'Onion - Red Creole',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 3,
    rowSpacing: 8,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'shallot onion. intermediate-day variety. Mild gourmet flavor, clustered bulbs.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '2-3 inches',
    family: 'Amaryllidaceae',
    varieties: ['Red Creole'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-white-bermuda',
    name: 'Onion - White Bermuda',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'yellow onion. long-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['White Bermuda'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-evergreen-bunching',
    name: 'Onion - Evergreen Bunching',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'red onion. short-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Evergreen Bunching'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-red-baron',
    name: 'Onion - Red Baron',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'white onion. intermediate-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Red Baron'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-texas-early-grano',
    name: 'Onion - Texas Early Grano',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'sweet onion. long-day variety. Mild and sweet, perfect for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Texas Early Grano'],
    uses: ['fresh', 'salads', 'burgers']
  },
  {
    id: 'onion-utah-yellow-sweet-spanish',
    name: 'Onion - Utah Yellow Sweet Spanish',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'storage onion. short-day variety. Pungent and long-keeping.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Utah Yellow Sweet Spanish'],
    uses: ['cooking', 'storage', 'caramelizing']
  },
  {
    id: 'onion-southport-red-globe',
    name: 'Onion - Southport Red Globe',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 3,
    rowSpacing: 8,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'bunching onion. intermediate-day variety. Harvest young as green onions.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '2-3 inches',
    family: 'Amaryllidaceae',
    varieties: ['Southport Red Globe'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-southport-white-globe',
    name: 'Onion - Southport White Globe',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 3,
    rowSpacing: 8,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'shallot onion. long-day variety. Mild gourmet flavor, clustered bulbs.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '2-3 inches',
    family: 'Amaryllidaceae',
    varieties: ['Southport White Globe'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-ailsa-craig',
    name: 'Onion - Ailsa Craig',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'yellow onion. short-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Ailsa Craig'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-bedfordshire-champion',
    name: 'Onion - Bedfordshire Champion',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'red onion. intermediate-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Bedfordshire Champion'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-borrettana-cipollini',
    name: 'Onion - Borrettana Cipollini',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'white onion. long-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Borrettana Cipollini'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-brunswick',
    name: 'Onion - Brunswick',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'sweet onion. short-day variety. Mild and sweet, perfect for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Brunswick'],
    uses: ['fresh', 'salads', 'burgers']
  },
  {
    id: 'onion-cabernet',
    name: 'Onion - Cabernet',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'storage onion. intermediate-day variety. Pungent and long-keeping.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Cabernet'],
    uses: ['cooking', 'storage', 'caramelizing']
  },
  {
    id: 'onion-copra',
    name: 'Onion - Copra',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 3,
    rowSpacing: 8,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'bunching onion. long-day variety. Harvest young as green onions.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '2-3 inches',
    family: 'Amaryllidaceae',
    varieties: ['Copra'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-dakota-tears',
    name: 'Onion - Dakota Tears',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 3,
    rowSpacing: 8,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'shallot onion. short-day variety. Mild gourmet flavor, clustered bulbs.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '2-3 inches',
    family: 'Amaryllidaceae',
    varieties: ['Dakota Tears'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-dorata-di-parma',
    name: 'Onion - Dorata di Parma',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'yellow onion. intermediate-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Dorata di Parma'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-ebenezer',
    name: 'Onion - Ebenezer',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'red onion. long-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Ebenezer'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-expression',
    name: 'Onion - Expression',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'white onion. short-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Expression'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-first-edition',
    name: 'Onion - First Edition',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'sweet onion. intermediate-day variety. Mild and sweet, perfect for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['First Edition'],
    uses: ['fresh', 'salads', 'burgers']
  },
  {
    id: 'onion-frontier',
    name: 'Onion - Frontier',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'storage onion. long-day variety. Pungent and long-keeping.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Frontier'],
    uses: ['cooking', 'storage', 'caramelizing']
  },
  {
    id: 'onion-gladstone',
    name: 'Onion - Gladstone',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 3,
    rowSpacing: 8,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'bunching onion. short-day variety. Harvest young as green onions.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '2-3 inches',
    family: 'Amaryllidaceae',
    varieties: ['Gladstone'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-gold-princess',
    name: 'Onion - Gold Princess',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 3,
    rowSpacing: 8,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'shallot onion. intermediate-day variety. Mild gourmet flavor, clustered bulbs.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '2-3 inches',
    family: 'Amaryllidaceae',
    varieties: ['Gold Princess'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-golden-cascade',
    name: 'Onion - Golden Cascade',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'yellow onion. long-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Golden Cascade'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-golden-gourmet',
    name: 'Onion - Golden Gourmet',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'red onion. short-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Golden Gourmet'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-hercules',
    name: 'Onion - Hercules',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'white onion. intermediate-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Hercules'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-highlander',
    name: 'Onion - Highlander',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'sweet onion. long-day variety. Mild and sweet, perfect for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Highlander'],
    uses: ['fresh', 'salads', 'burgers']
  },
  {
    id: 'onion-ishikura-long-white',
    name: 'Onion - Ishikura Long White',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'storage onion. short-day variety. Pungent and long-keeping.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Ishikura Long White'],
    uses: ['cooking', 'storage', 'caramelizing']
  },
  {
    id: 'onion-italian-red-of-florence',
    name: 'Onion - Italian Red of Florence',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 3,
    rowSpacing: 8,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'bunching onion. intermediate-day variety. Harvest young as green onions.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '2-3 inches',
    family: 'Amaryllidaceae',
    varieties: ['Italian Red of Florence'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-jaune-paille-des-vertus',
    name: 'Onion - Jaune Paille des Vertus',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 3,
    rowSpacing: 8,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'shallot onion. long-day variety. Mild gourmet flavor, clustered bulbs.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '2-3 inches',
    family: 'Amaryllidaceae',
    varieties: ['Jaune Paille des Vertus'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-kelsae',
    name: 'Onion - Kelsae',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'yellow onion. short-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Kelsae'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-king-richard',
    name: 'Onion - King Richard',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'red onion. intermediate-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['King Richard'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-la-reine',
    name: 'Onion - La Reine',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'white onion. long-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['La Reine'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-lancelot-leek',
    name: 'Onion - Lancelot Leek',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'sweet onion. short-day variety. Mild and sweet, perfect for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Lancelot Leek'],
    uses: ['fresh', 'salads', 'burgers']
  },
  {
    id: 'onion-long-red-florence',
    name: 'Onion - Long Red Florence',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'storage onion. intermediate-day variety. Pungent and long-keeping.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Long Red Florence'],
    uses: ['cooking', 'storage', 'caramelizing']
  },
  {
    id: 'onion-long-white-tokyo',
    name: 'Onion - Long White Tokyo',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 3,
    rowSpacing: 8,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'bunching onion. long-day variety. Harvest young as green onions.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '2-3 inches',
    family: 'Amaryllidaceae',
    varieties: ['Long White Tokyo'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-magnate',
    name: 'Onion - Magnate',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 3,
    rowSpacing: 8,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'shallot onion. short-day variety. Mild gourmet flavor, clustered bulbs.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '2-3 inches',
    family: 'Amaryllidaceae',
    varieties: ['Magnate'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-martina',
    name: 'Onion - Martina',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'yellow onion. intermediate-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Martina'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-monastrell',
    name: 'Onion - Monastrell',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'red onion. long-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Monastrell'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-monique',
    name: 'Onion - Monique',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'white onion. short-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Monique'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-nabechan',
    name: 'Onion - Nabechan',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'sweet onion. intermediate-day variety. Mild and sweet, perfect for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Nabechan'],
    uses: ['fresh', 'salads', 'burgers']
  },
  {
    id: 'onion-new-york-early',
    name: 'Onion - New York Early',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'storage onion. long-day variety. Pungent and long-keeping.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['New York Early'],
    uses: ['cooking', 'storage', 'caramelizing']
  },
  {
    id: 'onion-olympic',
    name: 'Onion - Olympic',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 3,
    rowSpacing: 8,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'bunching onion. short-day variety. Harvest young as green onions.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '2-3 inches',
    family: 'Amaryllidaceae',
    varieties: ['Olympic'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-patterson',
    name: 'Onion - Patterson',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 3,
    rowSpacing: 8,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'shallot onion. intermediate-day variety. Mild gourmet flavor, clustered bulbs.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '2-3 inches',
    family: 'Amaryllidaceae',
    varieties: ['Patterson'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-pompeii',
    name: 'Onion - Pompeii',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'yellow onion. long-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Pompeii'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-prince',
    name: 'Onion - Prince',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'red onion. short-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Prince'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-purplette',
    name: 'Onion - Purplette',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'white onion. intermediate-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Purplette'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-rossa-di-milano',
    name: 'Onion - Rossa di Milano',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'sweet onion. long-day variety. Mild and sweet, perfect for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Rossa di Milano'],
    uses: ['fresh', 'salads', 'burgers']
  },
  {
    id: 'onion-rossa-lunga-di-firenze',
    name: 'Onion - Rossa Lunga di Firenze',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'storage onion. short-day variety. Pungent and long-keeping.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Rossa Lunga di Firenze'],
    uses: ['cooking', 'storage', 'caramelizing']
  },
  {
    id: 'onion-rover',
    name: 'Onion - Rover',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 3,
    rowSpacing: 8,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'bunching onion. intermediate-day variety. Harvest young as green onions.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '2-3 inches',
    family: 'Amaryllidaceae',
    varieties: ['Rover'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-rumba',
    name: 'Onion - Rumba',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 3,
    rowSpacing: 8,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'shallot onion. long-day variety. Mild gourmet flavor, clustered bulbs.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '2-3 inches',
    family: 'Amaryllidaceae',
    varieties: ['Rumba'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-saffron',
    name: 'Onion - Saffron',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'yellow onion. short-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Saffron'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-sapporo-ki',
    name: 'Onion - Sapporo-Ki',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'red onion. intermediate-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Sapporo-Ki'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-sedona',
    name: 'Onion - Sedona',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'white onion. long-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Sedona'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-senshyu-yellow-globe',
    name: 'Onion - Senshyu Yellow Globe',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'sweet onion. short-day variety. Mild and sweet, perfect for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Senshyu Yellow Globe'],
    uses: ['fresh', 'salads', 'burgers']
  },
  {
    id: 'onion-shakespeare',
    name: 'Onion - Shakespeare',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'storage onion. intermediate-day variety. Pungent and long-keeping.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Shakespeare'],
    uses: ['cooking', 'storage', 'caramelizing']
  },
  {
    id: 'onion-sherry',
    name: 'Onion - Sherry',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 3,
    rowSpacing: 8,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'bunching onion. long-day variety. Harvest young as green onions.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '2-3 inches',
    family: 'Amaryllidaceae',
    varieties: ['Sherry'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-silver-king',
    name: 'Onion - Silver King',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 3,
    rowSpacing: 8,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'shallot onion. short-day variety. Mild gourmet flavor, clustered bulbs.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '2-3 inches',
    family: 'Amaryllidaceae',
    varieties: ['Silver King'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-snowball',
    name: 'Onion - Snowball',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'yellow onion. intermediate-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Snowball'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-space',
    name: 'Onion - Space',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'red onion. long-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Space'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-spanish-medusa',
    name: 'Onion - Spanish Medusa',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'white onion. short-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Spanish Medusa'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-spanish-roja',
    name: 'Onion - Spanish Roja',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'sweet onion. intermediate-day variety. Mild and sweet, perfect for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Spanish Roja'],
    uses: ['fresh', 'salads', 'burgers']
  },
  {
    id: 'onion-stuttgarter',
    name: 'Onion - Stuttgarter',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'storage onion. long-day variety. Pungent and long-keeping.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Stuttgarter'],
    uses: ['cooking', 'storage', 'caramelizing']
  },
  {
    id: 'onion-sturon',
    name: 'Onion - Sturon',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 3,
    rowSpacing: 8,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'bunching onion. short-day variety. Harvest young as green onions.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '2-3 inches',
    family: 'Amaryllidaceae',
    varieties: ['Sturon'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-talon',
    name: 'Onion - Talon',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 3,
    rowSpacing: 8,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'shallot onion. intermediate-day variety. Mild gourmet flavor, clustered bulbs.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '2-3 inches',
    family: 'Amaryllidaceae',
    varieties: ['Talon'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-top-keeper',
    name: 'Onion - Top Keeper',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'yellow onion. long-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Top Keeper'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-tropeana-lunga',
    name: 'Onion - Tropeana Lunga',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'red onion. short-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Tropeana Lunga'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-valenciana-tardia',
    name: 'Onion - Valenciana Tardia',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'white onion. intermediate-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Valenciana Tardia'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-vision',
    name: 'Onion - Vision',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'sweet onion. long-day variety. Mild and sweet, perfect for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Vision'],
    uses: ['fresh', 'salads', 'burgers']
  },
  {
    id: 'onion-walla-walla',
    name: 'Onion - Walla Walla',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'storage onion. short-day variety. Pungent and long-keeping.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Walla Walla'],
    uses: ['cooking', 'storage', 'caramelizing']
  },
  {
    id: 'onion-warrior',
    name: 'Onion - Warrior',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 3,
    rowSpacing: 8,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'bunching onion. intermediate-day variety. Harvest young as green onions.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '2-3 inches',
    family: 'Amaryllidaceae',
    varieties: ['Warrior'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-watch-keeper',
    name: 'Onion - Watch Keeper',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 3,
    rowSpacing: 8,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'shallot onion. long-day variety. Mild gourmet flavor, clustered bulbs.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '2-3 inches',
    family: 'Amaryllidaceae',
    varieties: ['Watch Keeper'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-white-lisbon',
    name: 'Onion - White Lisbon',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'yellow onion. short-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['White Lisbon'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-white-spear',
    name: 'Onion - White Spear',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'red onion. intermediate-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['White Spear'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-wolverine',
    name: 'Onion - Wolverine',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'white onion. long-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Wolverine'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-yellow-granex',
    name: 'Onion - Yellow Granex',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'sweet onion. short-day variety. Mild and sweet, perfect for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Yellow Granex'],
    uses: ['fresh', 'salads', 'burgers']
  },
  {
    id: 'onion-yellow-sweet-spanish',
    name: 'Onion - Yellow Sweet Spanish',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'storage onion. intermediate-day variety. Pungent and long-keeping.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Yellow Sweet Spanish'],
    uses: ['cooking', 'storage', 'caramelizing']
  },
  {
    id: 'onion-zoey',
    name: 'Onion - Zoey',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 3,
    rowSpacing: 8,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'bunching onion. long-day variety. Harvest young as green onions.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '2-3 inches',
    family: 'Amaryllidaceae',
    varieties: ['Zoey'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-zuta',
    name: 'Onion - Zuta',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 3,
    rowSpacing: 8,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'shallot onion. short-day variety. Mild gourmet flavor, clustered bulbs.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '2-3 inches',
    family: 'Amaryllidaceae',
    varieties: ['Zuta'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-zermatt',
    name: 'Onion - Zermatt',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'yellow onion. intermediate-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Zermatt'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-walla-walla-2',
    name: 'Onion - Walla Walla 2',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'red onion. long-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Walla Walla 2'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-sweet-spanish-2',
    name: 'Onion - Sweet Spanish 2',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'white onion. short-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Sweet Spanish 2'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-red-burgundy-2',
    name: 'Onion - Red Burgundy 2',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'sweet onion. intermediate-day variety. Mild and sweet, perfect for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Red Burgundy 2'],
    uses: ['fresh', 'salads', 'burgers']
  },
  {
    id: 'onion-yellow-sweet-spanish-2',
    name: 'Onion - Yellow Sweet Spanish 2',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'storage onion. long-day variety. Pungent and long-keeping.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Yellow Sweet Spanish 2'],
    uses: ['cooking', 'storage', 'caramelizing']
  },
  {
    id: 'onion-texas-grano-2',
    name: 'Onion - Texas Grano 2',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 3,
    rowSpacing: 8,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'bunching onion. short-day variety. Harvest young as green onions.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '2-3 inches',
    family: 'Amaryllidaceae',
    varieties: ['Texas Grano 2'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-vidalia-2',
    name: 'Onion - Vidalia 2',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 3,
    rowSpacing: 8,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'shallot onion. intermediate-day variety. Mild gourmet flavor, clustered bulbs.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '2-3 inches',
    family: 'Amaryllidaceae',
    varieties: ['Vidalia 2'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-maui-2',
    name: 'Onion - Maui 2',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'yellow onion. long-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Maui 2'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-walla-walla-sweet-2',
    name: 'Onion - Walla Walla Sweet 2',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'red onion. short-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Walla Walla Sweet 2'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-candy-2',
    name: 'Onion - Candy 2',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'white onion. intermediate-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Candy 2'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-super-star-2',
    name: 'Onion - Super Star 2',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'sweet onion. long-day variety. Mild and sweet, perfect for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Super Star 2'],
    uses: ['fresh', 'salads', 'burgers']
  },
  {
    id: 'onion-red-zeppelin-2',
    name: 'Onion - Red Zeppelin 2',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'storage onion. short-day variety. Pungent and long-keeping.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Red Zeppelin 2'],
    uses: ['cooking', 'storage', 'caramelizing']
  },
  {
    id: 'onion-ringmaster-2',
    name: 'Onion - Ringmaster 2',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 3,
    rowSpacing: 8,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'bunching onion. intermediate-day variety. Harvest young as green onions.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '2-3 inches',
    family: 'Amaryllidaceae',
    varieties: ['Ringmaster 2'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-yellow-granex-2',
    name: 'Onion - Yellow Granex 2',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 3,
    rowSpacing: 8,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'shallot onion. long-day variety. Mild gourmet flavor, clustered bulbs.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '2-3 inches',
    family: 'Amaryllidaceae',
    varieties: ['Yellow Granex 2'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-red-creole-2',
    name: 'Onion - Red Creole 2',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'yellow onion. short-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Red Creole 2'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-white-bermuda-2',
    name: 'Onion - White Bermuda 2',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'red onion. intermediate-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['White Bermuda 2'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-evergreen-bunching-2',
    name: 'Onion - Evergreen Bunching 2',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'white onion. long-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Evergreen Bunching 2'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-red-baron-2',
    name: 'Onion - Red Baron 2',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'sweet onion. short-day variety. Mild and sweet, perfect for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Red Baron 2'],
    uses: ['fresh', 'salads', 'burgers']
  },
  {
    id: 'onion-texas-early-grano-2',
    name: 'Onion - Texas Early Grano 2',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'storage onion. intermediate-day variety. Pungent and long-keeping.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Texas Early Grano 2'],
    uses: ['cooking', 'storage', 'caramelizing']
  },
  {
    id: 'onion-utah-yellow-sweet-spanish-2',
    name: 'Onion - Utah Yellow Sweet Spanish 2',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 3,
    rowSpacing: 8,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'bunching onion. long-day variety. Harvest young as green onions.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '2-3 inches',
    family: 'Amaryllidaceae',
    varieties: ['Utah Yellow Sweet Spanish 2'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-southport-red-globe-2',
    name: 'Onion - Southport Red Globe 2',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 3,
    rowSpacing: 8,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'shallot onion. short-day variety. Mild gourmet flavor, clustered bulbs.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '2-3 inches',
    family: 'Amaryllidaceae',
    varieties: ['Southport Red Globe 2'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-southport-white-globe-2',
    name: 'Onion - Southport White Globe 2',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'yellow onion. intermediate-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Southport White Globe 2'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-ailsa-craig-2',
    name: 'Onion - Ailsa Craig 2',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'red onion. long-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Ailsa Craig 2'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-bedfordshire-champion-2',
    name: 'Onion - Bedfordshire Champion 2',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'white onion. short-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Bedfordshire Champion 2'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-borrettana-cipollini-2',
    name: 'Onion - Borrettana Cipollini 2',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'sweet onion. intermediate-day variety. Mild and sweet, perfect for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Borrettana Cipollini 2'],
    uses: ['fresh', 'salads', 'burgers']
  },
  {
    id: 'onion-brunswick-2',
    name: 'Onion - Brunswick 2',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'storage onion. long-day variety. Pungent and long-keeping.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Brunswick 2'],
    uses: ['cooking', 'storage', 'caramelizing']
  },
  {
    id: 'onion-cabernet-2',
    name: 'Onion - Cabernet 2',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 3,
    rowSpacing: 8,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'bunching onion. short-day variety. Harvest young as green onions.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '2-3 inches',
    family: 'Amaryllidaceae',
    varieties: ['Cabernet 2'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-copra-2',
    name: 'Onion - Copra 2',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 3,
    rowSpacing: 8,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'shallot onion. intermediate-day variety. Mild gourmet flavor, clustered bulbs.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '2-3 inches',
    family: 'Amaryllidaceae',
    varieties: ['Copra 2'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-dakota-tears-2',
    name: 'Onion - Dakota Tears 2',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'yellow onion. long-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Dakota Tears 2'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-dorata-di-parma-2',
    name: 'Onion - Dorata di Parma 2',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'red onion. short-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Dorata di Parma 2'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-ebenezer-2',
    name: 'Onion - Ebenezer 2',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'white onion. intermediate-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Ebenezer 2'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-expression-2',
    name: 'Onion - Expression 2',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'sweet onion. long-day variety. Mild and sweet, perfect for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Expression 2'],
    uses: ['fresh', 'salads', 'burgers']
  },
  {
    id: 'onion-first-edition-2',
    name: 'Onion - First Edition 2',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'storage onion. short-day variety. Pungent and long-keeping.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['First Edition 2'],
    uses: ['cooking', 'storage', 'caramelizing']
  },
  {
    id: 'onion-frontier-2',
    name: 'Onion - Frontier 2',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 3,
    rowSpacing: 8,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'bunching onion. intermediate-day variety. Harvest young as green onions.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '2-3 inches',
    family: 'Amaryllidaceae',
    varieties: ['Frontier 2'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-gladstone-2',
    name: 'Onion - Gladstone 2',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 3,
    rowSpacing: 8,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'shallot onion. long-day variety. Mild gourmet flavor, clustered bulbs.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '2-3 inches',
    family: 'Amaryllidaceae',
    varieties: ['Gladstone 2'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-gold-princess-2',
    name: 'Onion - Gold Princess 2',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'yellow onion. short-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Gold Princess 2'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-golden-cascade-2',
    name: 'Onion - Golden Cascade 2',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'red onion. intermediate-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Golden Cascade 2'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-golden-gourmet-2',
    name: 'Onion - Golden Gourmet 2',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'white onion. long-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Golden Gourmet 2'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-hercules-2',
    name: 'Onion - Hercules 2',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'sweet onion. short-day variety. Mild and sweet, perfect for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Hercules 2'],
    uses: ['fresh', 'salads', 'burgers']
  },
  {
    id: 'onion-highlander-2',
    name: 'Onion - Highlander 2',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'storage onion. intermediate-day variety. Pungent and long-keeping.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Highlander 2'],
    uses: ['cooking', 'storage', 'caramelizing']
  },
  {
    id: 'onion-ishikura-long-white-2',
    name: 'Onion - Ishikura Long White 2',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 3,
    rowSpacing: 8,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'bunching onion. long-day variety. Harvest young as green onions.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '2-3 inches',
    family: 'Amaryllidaceae',
    varieties: ['Ishikura Long White 2'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-italian-red-of-florence-2',
    name: 'Onion - Italian Red of Florence 2',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 3,
    rowSpacing: 8,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'shallot onion. short-day variety. Mild gourmet flavor, clustered bulbs.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '2-3 inches',
    family: 'Amaryllidaceae',
    varieties: ['Italian Red of Florence 2'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-jaune-paille-des-vertus-2',
    name: 'Onion - Jaune Paille des Vertus 2',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'yellow onion. intermediate-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Jaune Paille des Vertus 2'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-kelsae-2',
    name: 'Onion - Kelsae 2',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'red onion. long-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Kelsae 2'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-king-richard-2',
    name: 'Onion - King Richard 2',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'white onion. short-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['King Richard 2'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-la-reine-2',
    name: 'Onion - La Reine 2',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'sweet onion. intermediate-day variety. Mild and sweet, perfect for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['La Reine 2'],
    uses: ['fresh', 'salads', 'burgers']
  },
  {
    id: 'onion-lancelot-leek-2',
    name: 'Onion - Lancelot Leek 2',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'storage onion. long-day variety. Pungent and long-keeping.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Lancelot Leek 2'],
    uses: ['cooking', 'storage', 'caramelizing']
  },
  {
    id: 'onion-long-red-florence-2',
    name: 'Onion - Long Red Florence 2',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 3,
    rowSpacing: 8,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'bunching onion. short-day variety. Harvest young as green onions.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '2-3 inches',
    family: 'Amaryllidaceae',
    varieties: ['Long Red Florence 2'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-long-white-tokyo-2',
    name: 'Onion - Long White Tokyo 2',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 3,
    rowSpacing: 8,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'shallot onion. intermediate-day variety. Mild gourmet flavor, clustered bulbs.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '2-3 inches',
    family: 'Amaryllidaceae',
    varieties: ['Long White Tokyo 2'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-magnate-2',
    name: 'Onion - Magnate 2',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'yellow onion. long-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Magnate 2'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-martina-2',
    name: 'Onion - Martina 2',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'red onion. short-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Martina 2'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-monastrell-2',
    name: 'Onion - Monastrell 2',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'white onion. intermediate-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Monastrell 2'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-monique-2',
    name: 'Onion - Monique 2',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'sweet onion. long-day variety. Mild and sweet, perfect for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Monique 2'],
    uses: ['fresh', 'salads', 'burgers']
  },
  {
    id: 'onion-nabechan-2',
    name: 'Onion - Nabechan 2',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'storage onion. short-day variety. Pungent and long-keeping.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Nabechan 2'],
    uses: ['cooking', 'storage', 'caramelizing']
  },
  {
    id: 'onion-new-york-early-2',
    name: 'Onion - New York Early 2',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 3,
    rowSpacing: 8,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'bunching onion. intermediate-day variety. Harvest young as green onions.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '2-3 inches',
    family: 'Amaryllidaceae',
    varieties: ['New York Early 2'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-olympic-2',
    name: 'Onion - Olympic 2',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 3,
    rowSpacing: 8,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'shallot onion. long-day variety. Mild gourmet flavor, clustered bulbs.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '2-3 inches',
    family: 'Amaryllidaceae',
    varieties: ['Olympic 2'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-patterson-2',
    name: 'Onion - Patterson 2',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'yellow onion. short-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Patterson 2'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-pompeii-2',
    name: 'Onion - Pompeii 2',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'red onion. intermediate-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Pompeii 2'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-prince-2',
    name: 'Onion - Prince 2',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'white onion. long-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Prince 2'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-purplette-2',
    name: 'Onion - Purplette 2',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'sweet onion. short-day variety. Mild and sweet, perfect for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Purplette 2'],
    uses: ['fresh', 'salads', 'burgers']
  },
  {
    id: 'onion-rossa-di-milano-2',
    name: 'Onion - Rossa di Milano 2',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'storage onion. intermediate-day variety. Pungent and long-keeping.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Rossa di Milano 2'],
    uses: ['cooking', 'storage', 'caramelizing']
  },
  {
    id: 'onion-rossa-lunga-di-firenze-2',
    name: 'Onion - Rossa Lunga di Firenze 2',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 3,
    rowSpacing: 8,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'bunching onion. long-day variety. Harvest young as green onions.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '2-3 inches',
    family: 'Amaryllidaceae',
    varieties: ['Rossa Lunga di Firenze 2'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-rover-2',
    name: 'Onion - Rover 2',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 3,
    rowSpacing: 8,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'shallot onion. short-day variety. Mild gourmet flavor, clustered bulbs.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '2-3 inches',
    family: 'Amaryllidaceae',
    varieties: ['Rover 2'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-rumba-2',
    name: 'Onion - Rumba 2',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'yellow onion. intermediate-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Rumba 2'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-saffron-2',
    name: 'Onion - Saffron 2',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'red onion. long-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Saffron 2'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-sapporo-ki-2',
    name: 'Onion - Sapporo-Ki 2',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'white onion. short-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Sapporo-Ki 2'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-sedona-2',
    name: 'Onion - Sedona 2',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'sweet onion. intermediate-day variety. Mild and sweet, perfect for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Sedona 2'],
    uses: ['fresh', 'salads', 'burgers']
  },
  {
    id: 'onion-senshyu-yellow-globe-2',
    name: 'Onion - Senshyu Yellow Globe 2',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'storage onion. long-day variety. Pungent and long-keeping.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Senshyu Yellow Globe 2'],
    uses: ['cooking', 'storage', 'caramelizing']
  },
  {
    id: 'onion-shakespeare-2',
    name: 'Onion - Shakespeare 2',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 3,
    rowSpacing: 8,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'bunching onion. short-day variety. Harvest young as green onions.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '2-3 inches',
    family: 'Amaryllidaceae',
    varieties: ['Shakespeare 2'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-sherry-2',
    name: 'Onion - Sherry 2',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 3,
    rowSpacing: 8,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'shallot onion. intermediate-day variety. Mild gourmet flavor, clustered bulbs.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '2-3 inches',
    family: 'Amaryllidaceae',
    varieties: ['Sherry 2'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-silver-king-2',
    name: 'Onion - Silver King 2',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'yellow onion. long-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Silver King 2'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-snowball-2',
    name: 'Onion - Snowball 2',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'red onion. short-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Snowball 2'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-space-2',
    name: 'Onion - Space 2',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'white onion. intermediate-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Space 2'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-spanish-medusa-2',
    name: 'Onion - Spanish Medusa 2',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'sweet onion. long-day variety. Mild and sweet, perfect for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Spanish Medusa 2'],
    uses: ['fresh', 'salads', 'burgers']
  },
  {
    id: 'onion-spanish-roja-2',
    name: 'Onion - Spanish Roja 2',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'storage onion. short-day variety. Pungent and long-keeping.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Spanish Roja 2'],
    uses: ['cooking', 'storage', 'caramelizing']
  },
  {
    id: 'onion-stuttgarter-2',
    name: 'Onion - Stuttgarter 2',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 3,
    rowSpacing: 8,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'bunching onion. intermediate-day variety. Harvest young as green onions.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '2-3 inches',
    family: 'Amaryllidaceae',
    varieties: ['Stuttgarter 2'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-sturon-2',
    name: 'Onion - Sturon 2',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 3,
    rowSpacing: 8,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'shallot onion. long-day variety. Mild gourmet flavor, clustered bulbs.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '2-3 inches',
    family: 'Amaryllidaceae',
    varieties: ['Sturon 2'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-talon-2',
    name: 'Onion - Talon 2',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'yellow onion. short-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Talon 2'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-top-keeper-2',
    name: 'Onion - Top Keeper 2',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'red onion. intermediate-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Top Keeper 2'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-tropeana-lunga-2',
    name: 'Onion - Tropeana Lunga 2',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'white onion. long-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Tropeana Lunga 2'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-valenciana-tardia-2',
    name: 'Onion - Valenciana Tardia 2',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'sweet onion. short-day variety. Mild and sweet, perfect for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Valenciana Tardia 2'],
    uses: ['fresh', 'salads', 'burgers']
  },
  {
    id: 'onion-vision-2',
    name: 'Onion - Vision 2',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'storage onion. intermediate-day variety. Pungent and long-keeping.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Vision 2'],
    uses: ['cooking', 'storage', 'caramelizing']
  },
  {
    id: 'onion-walla-walla-2',
    name: 'Onion - Walla Walla 2',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 3,
    rowSpacing: 8,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'bunching onion. long-day variety. Harvest young as green onions.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '2-3 inches',
    family: 'Amaryllidaceae',
    varieties: ['Walla Walla 2'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-warrior-2',
    name: 'Onion - Warrior 2',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 3,
    rowSpacing: 8,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'shallot onion. short-day variety. Mild gourmet flavor, clustered bulbs.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '2-3 inches',
    family: 'Amaryllidaceae',
    varieties: ['Warrior 2'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-watch-keeper-2',
    name: 'Onion - Watch Keeper 2',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'yellow onion. intermediate-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Watch Keeper 2'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-white-lisbon-2',
    name: 'Onion - White Lisbon 2',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'red onion. long-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['White Lisbon 2'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-white-spear-2',
    name: 'Onion - White Spear 2',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'white onion. short-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['White Spear 2'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-wolverine-2',
    name: 'Onion - Wolverine 2',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'sweet onion. intermediate-day variety. Mild and sweet, perfect for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Wolverine 2'],
    uses: ['fresh', 'salads', 'burgers']
  },
  {
    id: 'onion-yellow-granex-2',
    name: 'Onion - Yellow Granex 2',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'storage onion. long-day variety. Pungent and long-keeping.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Yellow Granex 2'],
    uses: ['cooking', 'storage', 'caramelizing']
  },
  {
    id: 'onion-yellow-sweet-spanish-2',
    name: 'Onion - Yellow Sweet Spanish 2',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 3,
    rowSpacing: 8,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'bunching onion. short-day variety. Harvest young as green onions.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '2-3 inches',
    family: 'Amaryllidaceae',
    varieties: ['Yellow Sweet Spanish 2'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-zoey-2',
    name: 'Onion - Zoey 2',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 3,
    rowSpacing: 8,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'shallot onion. intermediate-day variety. Mild gourmet flavor, clustered bulbs.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '2-3 inches',
    family: 'Amaryllidaceae',
    varieties: ['Zoey 2'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-zuta-2',
    name: 'Onion - Zuta 2',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'yellow onion. long-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Zuta 2'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-zermatt-2',
    name: 'Onion - Zermatt 2',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'red onion. short-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Zermatt 2'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-walla-walla-3',
    name: 'Onion - Walla Walla 3',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'white onion. intermediate-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Walla Walla 3'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-sweet-spanish-3',
    name: 'Onion - Sweet Spanish 3',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'sweet onion. long-day variety. Mild and sweet, perfect for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Sweet Spanish 3'],
    uses: ['fresh', 'salads', 'burgers']
  },
  {
    id: 'onion-red-burgundy-3',
    name: 'Onion - Red Burgundy 3',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'storage onion. short-day variety. Pungent and long-keeping.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Red Burgundy 3'],
    uses: ['cooking', 'storage', 'caramelizing']
  },
  {
    id: 'onion-yellow-sweet-spanish-3',
    name: 'Onion - Yellow Sweet Spanish 3',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 3,
    rowSpacing: 8,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'bunching onion. intermediate-day variety. Harvest young as green onions.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '2-3 inches',
    family: 'Amaryllidaceae',
    varieties: ['Yellow Sweet Spanish 3'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-texas-grano-3',
    name: 'Onion - Texas Grano 3',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 3,
    rowSpacing: 8,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'shallot onion. long-day variety. Mild gourmet flavor, clustered bulbs.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '2-3 inches',
    family: 'Amaryllidaceae',
    varieties: ['Texas Grano 3'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-vidalia-3',
    name: 'Onion - Vidalia 3',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'yellow onion. short-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Vidalia 3'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-maui-3',
    name: 'Onion - Maui 3',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'red onion. intermediate-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Maui 3'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-walla-walla-sweet-3',
    name: 'Onion - Walla Walla Sweet 3',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'white onion. long-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Walla Walla Sweet 3'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-candy-3',
    name: 'Onion - Candy 3',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'sweet onion. short-day variety. Mild and sweet, perfect for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Candy 3'],
    uses: ['fresh', 'salads', 'burgers']
  },
  {
    id: 'onion-super-star-3',
    name: 'Onion - Super Star 3',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'storage onion. intermediate-day variety. Pungent and long-keeping.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Super Star 3'],
    uses: ['cooking', 'storage', 'caramelizing']
  },
  {
    id: 'onion-red-zeppelin-3',
    name: 'Onion - Red Zeppelin 3',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 3,
    rowSpacing: 8,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'bunching onion. long-day variety. Harvest young as green onions.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '2-3 inches',
    family: 'Amaryllidaceae',
    varieties: ['Red Zeppelin 3'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-ringmaster-3',
    name: 'Onion - Ringmaster 3',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 3,
    rowSpacing: 8,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'shallot onion. short-day variety. Mild gourmet flavor, clustered bulbs.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '2-3 inches',
    family: 'Amaryllidaceae',
    varieties: ['Ringmaster 3'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-yellow-granex-3',
    name: 'Onion - Yellow Granex 3',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'yellow onion. intermediate-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Yellow Granex 3'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-red-creole-3',
    name: 'Onion - Red Creole 3',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'red onion. long-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Red Creole 3'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-white-bermuda-3',
    name: 'Onion - White Bermuda 3',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'white onion. short-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['White Bermuda 3'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-evergreen-bunching-3',
    name: 'Onion - Evergreen Bunching 3',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'sweet onion. intermediate-day variety. Mild and sweet, perfect for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Evergreen Bunching 3'],
    uses: ['fresh', 'salads', 'burgers']
  },
  {
    id: 'onion-red-baron-3',
    name: 'Onion - Red Baron 3',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'storage onion. long-day variety. Pungent and long-keeping.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Red Baron 3'],
    uses: ['cooking', 'storage', 'caramelizing']
  },
  {
    id: 'onion-texas-early-grano-3',
    name: 'Onion - Texas Early Grano 3',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 3,
    rowSpacing: 8,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'bunching onion. short-day variety. Harvest young as green onions.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '2-3 inches',
    family: 'Amaryllidaceae',
    varieties: ['Texas Early Grano 3'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-utah-yellow-sweet-spanish-3',
    name: 'Onion - Utah Yellow Sweet Spanish 3',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 3,
    rowSpacing: 8,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'shallot onion. intermediate-day variety. Mild gourmet flavor, clustered bulbs.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '2-3 inches',
    family: 'Amaryllidaceae',
    varieties: ['Utah Yellow Sweet Spanish 3'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-southport-red-globe-3',
    name: 'Onion - Southport Red Globe 3',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'yellow onion. long-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Southport Red Globe 3'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-southport-white-globe-3',
    name: 'Onion - Southport White Globe 3',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'red onion. short-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Southport White Globe 3'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-ailsa-craig-3',
    name: 'Onion - Ailsa Craig 3',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'white onion. intermediate-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Ailsa Craig 3'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-bedfordshire-champion-3',
    name: 'Onion - Bedfordshire Champion 3',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'sweet onion. long-day variety. Mild and sweet, perfect for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Bedfordshire Champion 3'],
    uses: ['fresh', 'salads', 'burgers']
  },
  {
    id: 'onion-borrettana-cipollini-3',
    name: 'Onion - Borrettana Cipollini 3',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'storage onion. short-day variety. Pungent and long-keeping.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Borrettana Cipollini 3'],
    uses: ['cooking', 'storage', 'caramelizing']
  },
  {
    id: 'onion-brunswick-3',
    name: 'Onion - Brunswick 3',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 3,
    rowSpacing: 8,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'bunching onion. intermediate-day variety. Harvest young as green onions.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '2-3 inches',
    family: 'Amaryllidaceae',
    varieties: ['Brunswick 3'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-cabernet-3',
    name: 'Onion - Cabernet 3',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 3,
    rowSpacing: 8,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'shallot onion. long-day variety. Mild gourmet flavor, clustered bulbs.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '2-3 inches',
    family: 'Amaryllidaceae',
    varieties: ['Cabernet 3'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-copra-3',
    name: 'Onion - Copra 3',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'yellow onion. short-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Copra 3'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-dakota-tears-3',
    name: 'Onion - Dakota Tears 3',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'red onion. intermediate-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Dakota Tears 3'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-dorata-di-parma-3',
    name: 'Onion - Dorata di Parma 3',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'white onion. long-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Dorata di Parma 3'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-ebenezer-3',
    name: 'Onion - Ebenezer 3',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'sweet onion. short-day variety. Mild and sweet, perfect for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Ebenezer 3'],
    uses: ['fresh', 'salads', 'burgers']
  },
  {
    id: 'onion-expression-3',
    name: 'Onion - Expression 3',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'storage onion. intermediate-day variety. Pungent and long-keeping.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Expression 3'],
    uses: ['cooking', 'storage', 'caramelizing']
  },
  {
    id: 'onion-first-edition-3',
    name: 'Onion - First Edition 3',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 3,
    rowSpacing: 8,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'bunching onion. long-day variety. Harvest young as green onions.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '2-3 inches',
    family: 'Amaryllidaceae',
    varieties: ['First Edition 3'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-frontier-3',
    name: 'Onion - Frontier 3',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 3,
    rowSpacing: 8,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'shallot onion. short-day variety. Mild gourmet flavor, clustered bulbs.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '2-3 inches',
    family: 'Amaryllidaceae',
    varieties: ['Frontier 3'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-gladstone-3',
    name: 'Onion - Gladstone 3',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'yellow onion. intermediate-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Gladstone 3'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-gold-princess-3',
    name: 'Onion - Gold Princess 3',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'red onion. long-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Gold Princess 3'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-golden-cascade-3',
    name: 'Onion - Golden Cascade 3',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'white onion. short-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Golden Cascade 3'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-golden-gourmet-3',
    name: 'Onion - Golden Gourmet 3',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'sweet onion. intermediate-day variety. Mild and sweet, perfect for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Golden Gourmet 3'],
    uses: ['fresh', 'salads', 'burgers']
  },
  {
    id: 'onion-hercules-3',
    name: 'Onion - Hercules 3',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'storage onion. long-day variety. Pungent and long-keeping.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Hercules 3'],
    uses: ['cooking', 'storage', 'caramelizing']
  },
  {
    id: 'onion-highlander-3',
    name: 'Onion - Highlander 3',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 3,
    rowSpacing: 8,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'bunching onion. short-day variety. Harvest young as green onions.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '2-3 inches',
    family: 'Amaryllidaceae',
    varieties: ['Highlander 3'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-ishikura-long-white-3',
    name: 'Onion - Ishikura Long White 3',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 3,
    rowSpacing: 8,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'shallot onion. intermediate-day variety. Mild gourmet flavor, clustered bulbs.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '2-3 inches',
    family: 'Amaryllidaceae',
    varieties: ['Ishikura Long White 3'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-italian-red-of-florence-3',
    name: 'Onion - Italian Red of Florence 3',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'yellow onion. long-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Italian Red of Florence 3'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-jaune-paille-des-vertus-3',
    name: 'Onion - Jaune Paille des Vertus 3',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'red onion. short-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Jaune Paille des Vertus 3'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-kelsae-3',
    name: 'Onion - Kelsae 3',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'white onion. intermediate-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Kelsae 3'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-king-richard-3',
    name: 'Onion - King Richard 3',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'sweet onion. long-day variety. Mild and sweet, perfect for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['King Richard 3'],
    uses: ['fresh', 'salads', 'burgers']
  },
  {
    id: 'onion-la-reine-3',
    name: 'Onion - La Reine 3',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'storage onion. short-day variety. Pungent and long-keeping.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['La Reine 3'],
    uses: ['cooking', 'storage', 'caramelizing']
  },
  {
    id: 'onion-lancelot-leek-3',
    name: 'Onion - Lancelot Leek 3',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 3,
    rowSpacing: 8,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'bunching onion. intermediate-day variety. Harvest young as green onions.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '2-3 inches',
    family: 'Amaryllidaceae',
    varieties: ['Lancelot Leek 3'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-long-red-florence-3',
    name: 'Onion - Long Red Florence 3',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 3,
    rowSpacing: 8,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'shallot onion. long-day variety. Mild gourmet flavor, clustered bulbs.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '2-3 inches',
    family: 'Amaryllidaceae',
    varieties: ['Long Red Florence 3'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-long-white-tokyo-3',
    name: 'Onion - Long White Tokyo 3',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'yellow onion. short-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Long White Tokyo 3'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-magnate-3',
    name: 'Onion - Magnate 3',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'red onion. intermediate-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Magnate 3'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-martina-3',
    name: 'Onion - Martina 3',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'white onion. long-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Martina 3'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-monastrell-3',
    name: 'Onion - Monastrell 3',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'sweet onion. short-day variety. Mild and sweet, perfect for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Monastrell 3'],
    uses: ['fresh', 'salads', 'burgers']
  },
  {
    id: 'onion-monique-3',
    name: 'Onion - Monique 3',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'storage onion. intermediate-day variety. Pungent and long-keeping.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Monique 3'],
    uses: ['cooking', 'storage', 'caramelizing']
  },
  {
    id: 'onion-nabechan-3',
    name: 'Onion - Nabechan 3',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 3,
    rowSpacing: 8,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'bunching onion. long-day variety. Harvest young as green onions.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '2-3 inches',
    family: 'Amaryllidaceae',
    varieties: ['Nabechan 3'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-new-york-early-3',
    name: 'Onion - New York Early 3',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 3,
    rowSpacing: 8,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'shallot onion. short-day variety. Mild gourmet flavor, clustered bulbs.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '2-3 inches',
    family: 'Amaryllidaceae',
    varieties: ['New York Early 3'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-olympic-3',
    name: 'Onion - Olympic 3',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'yellow onion. intermediate-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Olympic 3'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-patterson-3',
    name: 'Onion - Patterson 3',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'red onion. long-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Patterson 3'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-pompeii-3',
    name: 'Onion - Pompeii 3',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'white onion. short-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Pompeii 3'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-prince-3',
    name: 'Onion - Prince 3',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'sweet onion. intermediate-day variety. Mild and sweet, perfect for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Prince 3'],
    uses: ['fresh', 'salads', 'burgers']
  },
  {
    id: 'onion-purplette-3',
    name: 'Onion - Purplette 3',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'storage onion. long-day variety. Pungent and long-keeping.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Purplette 3'],
    uses: ['cooking', 'storage', 'caramelizing']
  },
  {
    id: 'onion-rossa-di-milano-3',
    name: 'Onion - Rossa di Milano 3',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 3,
    rowSpacing: 8,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'bunching onion. short-day variety. Harvest young as green onions.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '2-3 inches',
    family: 'Amaryllidaceae',
    varieties: ['Rossa di Milano 3'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-rossa-lunga-di-firenze-3',
    name: 'Onion - Rossa Lunga di Firenze 3',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 3,
    rowSpacing: 8,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'shallot onion. intermediate-day variety. Mild gourmet flavor, clustered bulbs.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '2-3 inches',
    family: 'Amaryllidaceae',
    varieties: ['Rossa Lunga di Firenze 3'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-rover-3',
    name: 'Onion - Rover 3',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'yellow onion. long-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Rover 3'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-rumba-3',
    name: 'Onion - Rumba 3',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'red onion. short-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Rumba 3'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-saffron-3',
    name: 'Onion - Saffron 3',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'white onion. intermediate-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Saffron 3'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-sapporo-ki-3',
    name: 'Onion - Sapporo-Ki 3',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'sweet onion. long-day variety. Mild and sweet, perfect for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Sapporo-Ki 3'],
    uses: ['fresh', 'salads', 'burgers']
  },
  {
    id: 'onion-sedona-3',
    name: 'Onion - Sedona 3',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'storage onion. short-day variety. Pungent and long-keeping.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Sedona 3'],
    uses: ['cooking', 'storage', 'caramelizing']
  },
  {
    id: 'onion-senshyu-yellow-globe-3',
    name: 'Onion - Senshyu Yellow Globe 3',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 3,
    rowSpacing: 8,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'bunching onion. intermediate-day variety. Harvest young as green onions.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '2-3 inches',
    family: 'Amaryllidaceae',
    varieties: ['Senshyu Yellow Globe 3'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-shakespeare-3',
    name: 'Onion - Shakespeare 3',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 3,
    rowSpacing: 8,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'shallot onion. long-day variety. Mild gourmet flavor, clustered bulbs.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '2-3 inches',
    family: 'Amaryllidaceae',
    varieties: ['Shakespeare 3'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-sherry-3',
    name: 'Onion - Sherry 3',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'yellow onion. short-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Sherry 3'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-silver-king-3',
    name: 'Onion - Silver King 3',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'red onion. intermediate-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Silver King 3'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-snowball-3',
    name: 'Onion - Snowball 3',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'white onion. long-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Snowball 3'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-space-3',
    name: 'Onion - Space 3',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'sweet onion. short-day variety. Mild and sweet, perfect for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Space 3'],
    uses: ['fresh', 'salads', 'burgers']
  },
  {
    id: 'onion-spanish-medusa-3',
    name: 'Onion - Spanish Medusa 3',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'storage onion. intermediate-day variety. Pungent and long-keeping.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Spanish Medusa 3'],
    uses: ['cooking', 'storage', 'caramelizing']
  },
  {
    id: 'onion-spanish-roja-3',
    name: 'Onion - Spanish Roja 3',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 3,
    rowSpacing: 8,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'bunching onion. long-day variety. Harvest young as green onions.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '2-3 inches',
    family: 'Amaryllidaceae',
    varieties: ['Spanish Roja 3'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-stuttgarter-3',
    name: 'Onion - Stuttgarter 3',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 3,
    rowSpacing: 8,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'shallot onion. short-day variety. Mild gourmet flavor, clustered bulbs.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '2-3 inches',
    family: 'Amaryllidaceae',
    varieties: ['Stuttgarter 3'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-sturon-3',
    name: 'Onion - Sturon 3',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'yellow onion. intermediate-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Sturon 3'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-talon-3',
    name: 'Onion - Talon 3',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'red onion. long-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Talon 3'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-top-keeper-3',
    name: 'Onion - Top Keeper 3',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'white onion. short-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Top Keeper 3'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-tropeana-lunga-3',
    name: 'Onion - Tropeana Lunga 3',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'sweet onion. intermediate-day variety. Mild and sweet, perfect for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Tropeana Lunga 3'],
    uses: ['fresh', 'salads', 'burgers']
  },
  {
    id: 'onion-valenciana-tardia-3',
    name: 'Onion - Valenciana Tardia 3',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'storage onion. long-day variety. Pungent and long-keeping.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Valenciana Tardia 3'],
    uses: ['cooking', 'storage', 'caramelizing']
  },
  {
    id: 'onion-vision-3',
    name: 'Onion - Vision 3',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 3,
    rowSpacing: 8,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'bunching onion. short-day variety. Harvest young as green onions.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '2-3 inches',
    family: 'Amaryllidaceae',
    varieties: ['Vision 3'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-walla-walla-3',
    name: 'Onion - Walla Walla 3',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 3,
    rowSpacing: 8,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'shallot onion. intermediate-day variety. Mild gourmet flavor, clustered bulbs.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '2-3 inches',
    family: 'Amaryllidaceae',
    varieties: ['Walla Walla 3'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-warrior-3',
    name: 'Onion - Warrior 3',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'yellow onion. long-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Warrior 3'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-watch-keeper-3',
    name: 'Onion - Watch Keeper 3',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'red onion. short-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Watch Keeper 3'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-white-lisbon-3',
    name: 'Onion - White Lisbon 3',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'white onion. intermediate-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['White Lisbon 3'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-white-spear-3',
    name: 'Onion - White Spear 3',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'sweet onion. long-day variety. Mild and sweet, perfect for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['White Spear 3'],
    uses: ['fresh', 'salads', 'burgers']
  },
  {
    id: 'onion-wolverine-3',
    name: 'Onion - Wolverine 3',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'storage onion. short-day variety. Pungent and long-keeping.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Wolverine 3'],
    uses: ['cooking', 'storage', 'caramelizing']
  },
  {
    id: 'onion-yellow-granex-3',
    name: 'Onion - Yellow Granex 3',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 3,
    rowSpacing: 8,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'bunching onion. intermediate-day variety. Harvest young as green onions.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '2-3 inches',
    family: 'Amaryllidaceae',
    varieties: ['Yellow Granex 3'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-yellow-sweet-spanish-3',
    name: 'Onion - Yellow Sweet Spanish 3',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 3,
    rowSpacing: 8,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'shallot onion. long-day variety. Mild gourmet flavor, clustered bulbs.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '2-3 inches',
    family: 'Amaryllidaceae',
    varieties: ['Yellow Sweet Spanish 3'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-zoey-3',
    name: 'Onion - Zoey 3',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'yellow onion. short-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Zoey 3'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-zuta-3',
    name: 'Onion - Zuta 3',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'red onion. intermediate-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Zuta 3'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-zermatt-3',
    name: 'Onion - Zermatt 3',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'white onion. long-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Zermatt 3'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-walla-walla-4',
    name: 'Onion - Walla Walla 4',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'sweet onion. short-day variety. Mild and sweet, perfect for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Walla Walla 4'],
    uses: ['fresh', 'salads', 'burgers']
  },
  {
    id: 'onion-sweet-spanish-4',
    name: 'Onion - Sweet Spanish 4',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'storage onion. intermediate-day variety. Pungent and long-keeping.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Sweet Spanish 4'],
    uses: ['cooking', 'storage', 'caramelizing']
  },
  {
    id: 'onion-red-burgundy-4',
    name: 'Onion - Red Burgundy 4',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 3,
    rowSpacing: 8,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'bunching onion. long-day variety. Harvest young as green onions.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '2-3 inches',
    family: 'Amaryllidaceae',
    varieties: ['Red Burgundy 4'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-yellow-sweet-spanish-4',
    name: 'Onion - Yellow Sweet Spanish 4',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 3,
    rowSpacing: 8,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'shallot onion. short-day variety. Mild gourmet flavor, clustered bulbs.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '2-3 inches',
    family: 'Amaryllidaceae',
    varieties: ['Yellow Sweet Spanish 4'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-texas-grano-4',
    name: 'Onion - Texas Grano 4',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'yellow onion. intermediate-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Texas Grano 4'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-vidalia-4',
    name: 'Onion - Vidalia 4',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'red onion. long-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Vidalia 4'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-maui-4',
    name: 'Onion - Maui 4',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'white onion. short-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Maui 4'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-walla-walla-sweet-4',
    name: 'Onion - Walla Walla Sweet 4',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'sweet onion. intermediate-day variety. Mild and sweet, perfect for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Walla Walla Sweet 4'],
    uses: ['fresh', 'salads', 'burgers']
  },
  {
    id: 'onion-candy-4',
    name: 'Onion - Candy 4',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'storage onion. long-day variety. Pungent and long-keeping.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Candy 4'],
    uses: ['cooking', 'storage', 'caramelizing']
  },
  {
    id: 'onion-super-star-4',
    name: 'Onion - Super Star 4',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 3,
    rowSpacing: 8,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'bunching onion. short-day variety. Harvest young as green onions.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '2-3 inches',
    family: 'Amaryllidaceae',
    varieties: ['Super Star 4'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-red-zeppelin-4',
    name: 'Onion - Red Zeppelin 4',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 3,
    rowSpacing: 8,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'shallot onion. intermediate-day variety. Mild gourmet flavor, clustered bulbs.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '2-3 inches',
    family: 'Amaryllidaceae',
    varieties: ['Red Zeppelin 4'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-ringmaster-4',
    name: 'Onion - Ringmaster 4',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'yellow onion. long-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Ringmaster 4'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-yellow-granex-4',
    name: 'Onion - Yellow Granex 4',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'red onion. short-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Yellow Granex 4'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-red-creole-4',
    name: 'Onion - Red Creole 4',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'white onion. intermediate-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Red Creole 4'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-white-bermuda-4',
    name: 'Onion - White Bermuda 4',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'sweet onion. long-day variety. Mild and sweet, perfect for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['White Bermuda 4'],
    uses: ['fresh', 'salads', 'burgers']
  },
  {
    id: 'onion-evergreen-bunching-4',
    name: 'Onion - Evergreen Bunching 4',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'storage onion. short-day variety. Pungent and long-keeping.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Evergreen Bunching 4'],
    uses: ['cooking', 'storage', 'caramelizing']
  },
  {
    id: 'onion-red-baron-4',
    name: 'Onion - Red Baron 4',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 3,
    rowSpacing: 8,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'bunching onion. intermediate-day variety. Harvest young as green onions.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '2-3 inches',
    family: 'Amaryllidaceae',
    varieties: ['Red Baron 4'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-texas-early-grano-4',
    name: 'Onion - Texas Early Grano 4',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 3,
    rowSpacing: 8,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'shallot onion. long-day variety. Mild gourmet flavor, clustered bulbs.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '2-3 inches',
    family: 'Amaryllidaceae',
    varieties: ['Texas Early Grano 4'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-utah-yellow-sweet-spanish-4',
    name: 'Onion - Utah Yellow Sweet Spanish 4',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'yellow onion. short-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Utah Yellow Sweet Spanish 4'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-southport-red-globe-4',
    name: 'Onion - Southport Red Globe 4',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'red onion. intermediate-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Southport Red Globe 4'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-southport-white-globe-4',
    name: 'Onion - Southport White Globe 4',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'white onion. long-day variety. Versatile all-purpose onion.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Southport White Globe 4'],
    uses: ['cooking', 'salads', 'fresh']
  },
  {
    id: 'onion-ailsa-craig-4',
    name: 'Onion - Ailsa Craig 4',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'sweet onion. short-day variety. Mild and sweet, perfect for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Ailsa Craig 4'],
    uses: ['fresh', 'salads', 'burgers']
  },
  {
    id: 'onion-bedfordshire-champion-4',
    name: 'Onion - Bedfordshire Champion 4',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 110,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'storage onion. intermediate-day variety. Pungent and long-keeping.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Bedfordshire Champion 4'],
    uses: ['cooking', 'storage', 'caramelizing']
  },
  {
    id: 'onion-borrettana-cipollini-4',
    name: 'Onion - Borrettana Cipollini 4',
    scientificName: 'Allium cepa',
    category: 'allium',
    spacing: 3,
    rowSpacing: 8,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato', 'strawberry'],
    enemies: ['bean', 'pea'],
    description: 'bunching onion. long-day variety. Harvest young as green onions.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '2-3 inches',
    family: 'Amaryllidaceae',
    varieties: ['Borrettana Cipollini 4'],
    uses: ['cooking', 'salads', 'fresh']
  }
,
  {
    id: 'garlic-music',
    name: 'Garlic - Music',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'hardneck garlic. Cold hardy, produces scapes, complex flavor. Plant in fall for summer harvest.',
    hardinessZones: '3-8',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Music'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-german-white',
    name: 'Garlic - German White',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'softneck garlic. Milder flavor, longer storage, no scapes. Plant in fall for summer harvest.',
    hardinessZones: '5-10',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['German White'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-chesnok-red',
    name: 'Garlic - Chesnok Red',
    scientificName: 'Allium ampeloprasum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 240,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'elephant garlic. Mild giant cloves, closer to leeks. Plant in fall for summer harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'fall',
    height: '3-4 feet',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Chesnok Red'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-inchelium-red',
    name: 'Garlic - Inchelium Red',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'hardneck garlic. Cold hardy, produces scapes, complex flavor. Plant in fall for summer harvest.',
    hardinessZones: '3-8',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Inchelium Red'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-california-early',
    name: 'Garlic - California Early',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'softneck garlic. Milder flavor, longer storage, no scapes. Plant in fall for summer harvest.',
    hardinessZones: '5-10',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['California Early'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-california-late',
    name: 'Garlic - California Late',
    scientificName: 'Allium ampeloprasum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 240,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'elephant garlic. Mild giant cloves, closer to leeks. Plant in fall for summer harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'fall',
    height: '3-4 feet',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['California Late'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-silver-rose',
    name: 'Garlic - Silver Rose',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'hardneck garlic. Cold hardy, produces scapes, complex flavor. Plant in fall for summer harvest.',
    hardinessZones: '3-8',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Silver Rose'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-silver-white',
    name: 'Garlic - Silver White',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'softneck garlic. Milder flavor, longer storage, no scapes. Plant in fall for summer harvest.',
    hardinessZones: '5-10',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Silver White'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-transylvanian',
    name: 'Garlic - Transylvanian',
    scientificName: 'Allium ampeloprasum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 240,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'elephant garlic. Mild giant cloves, closer to leeks. Plant in fall for summer harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'fall',
    height: '3-4 feet',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Transylvanian'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-spanish-roja',
    name: 'Garlic - Spanish Roja',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'hardneck garlic. Cold hardy, produces scapes, complex flavor. Plant in fall for summer harvest.',
    hardinessZones: '3-8',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Spanish Roja'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-russian-red',
    name: 'Garlic - Russian Red',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'softneck garlic. Milder flavor, longer storage, no scapes. Plant in fall for summer harvest.',
    hardinessZones: '5-10',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Russian Red'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-purple-glazer',
    name: 'Garlic - Purple Glazer',
    scientificName: 'Allium ampeloprasum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 240,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'elephant garlic. Mild giant cloves, closer to leeks. Plant in fall for summer harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'fall',
    height: '3-4 feet',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Purple Glazer'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-persian-star',
    name: 'Garlic - Persian Star',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'hardneck garlic. Cold hardy, produces scapes, complex flavor. Plant in fall for summer harvest.',
    hardinessZones: '3-8',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Persian Star'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-metechi',
    name: 'Garlic - Metechi',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'softneck garlic. Milder flavor, longer storage, no scapes. Plant in fall for summer harvest.',
    hardinessZones: '5-10',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Metechi'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-georgian-fire',
    name: 'Garlic - Georgian Fire',
    scientificName: 'Allium ampeloprasum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 240,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'elephant garlic. Mild giant cloves, closer to leeks. Plant in fall for summer harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'fall',
    height: '3-4 feet',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Georgian Fire'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-romanian-red',
    name: 'Garlic - Romanian Red',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'hardneck garlic. Cold hardy, produces scapes, complex flavor. Plant in fall for summer harvest.',
    hardinessZones: '3-8',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Romanian Red'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-bogatyr',
    name: 'Garlic - Bogatyr',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'softneck garlic. Milder flavor, longer storage, no scapes. Plant in fall for summer harvest.',
    hardinessZones: '5-10',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Bogatyr'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-german-red',
    name: 'Garlic - German Red',
    scientificName: 'Allium ampeloprasum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 240,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'elephant garlic. Mild giant cloves, closer to leeks. Plant in fall for summer harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'fall',
    height: '3-4 feet',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['German Red'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-german-extra-hardy',
    name: 'Garlic - German Extra Hardy',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'hardneck garlic. Cold hardy, produces scapes, complex flavor. Plant in fall for summer harvest.',
    hardinessZones: '3-8',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['German Extra Hardy'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-polish-hardneck',
    name: 'Garlic - Polish Hardneck',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'softneck garlic. Milder flavor, longer storage, no scapes. Plant in fall for summer harvest.',
    hardinessZones: '5-10',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Polish Hardneck'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-yugoslavian',
    name: 'Garlic - Yugoslavian',
    scientificName: 'Allium ampeloprasum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 240,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'elephant garlic. Mild giant cloves, closer to leeks. Plant in fall for summer harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'fall',
    height: '3-4 feet',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Yugoslavian'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-ajo-rojo',
    name: 'Garlic - Ajo Rojo',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'hardneck garlic. Cold hardy, produces scapes, complex flavor. Plant in fall for summer harvest.',
    hardinessZones: '3-8',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Ajo Rojo'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-killarney-red',
    name: 'Garlic - Killarney Red',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'softneck garlic. Milder flavor, longer storage, no scapes. Plant in fall for summer harvest.',
    hardinessZones: '5-10',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Killarney Red'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-lorz-italian',
    name: 'Garlic - Lorz Italian',
    scientificName: 'Allium ampeloprasum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 240,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'elephant garlic. Mild giant cloves, closer to leeks. Plant in fall for summer harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'fall',
    height: '3-4 feet',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Lorz Italian'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-inchelium',
    name: 'Garlic - Inchelium',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'hardneck garlic. Cold hardy, produces scapes, complex flavor. Plant in fall for summer harvest.',
    hardinessZones: '3-8',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Inchelium'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-susanville',
    name: 'Garlic - Susanville',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'softneck garlic. Milder flavor, longer storage, no scapes. Plant in fall for summer harvest.',
    hardinessZones: '5-10',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Susanville'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-idaho-silver',
    name: 'Garlic - Idaho Silver',
    scientificName: 'Allium ampeloprasum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 240,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'elephant garlic. Mild giant cloves, closer to leeks. Plant in fall for summer harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'fall',
    height: '3-4 feet',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Idaho Silver'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-oregon-blue',
    name: 'Garlic - Oregon Blue',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'hardneck garlic. Cold hardy, produces scapes, complex flavor. Plant in fall for summer harvest.',
    hardinessZones: '3-8',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Oregon Blue'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-kettle-river-giant',
    name: 'Garlic - Kettle River Giant',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'softneck garlic. Milder flavor, longer storage, no scapes. Plant in fall for summer harvest.',
    hardinessZones: '5-10',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Kettle River Giant'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-applegate',
    name: 'Garlic - Applegate',
    scientificName: 'Allium ampeloprasum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 240,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'elephant garlic. Mild giant cloves, closer to leeks. Plant in fall for summer harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'fall',
    height: '3-4 feet',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Applegate'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-asian-tempest',
    name: 'Garlic - Asian Tempest',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'hardneck garlic. Cold hardy, produces scapes, complex flavor. Plant in fall for summer harvest.',
    hardinessZones: '3-8',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Asian Tempest'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-basque',
    name: 'Garlic - Basque',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'softneck garlic. Milder flavor, longer storage, no scapes. Plant in fall for summer harvest.',
    hardinessZones: '5-10',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Basque'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-belarus',
    name: 'Garlic - Belarus',
    scientificName: 'Allium ampeloprasum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 240,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'elephant garlic. Mild giant cloves, closer to leeks. Plant in fall for summer harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'fall',
    height: '3-4 feet',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Belarus'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-brown-rose',
    name: 'Garlic - Brown Rose',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'hardneck garlic. Cold hardy, produces scapes, complex flavor. Plant in fall for summer harvest.',
    hardinessZones: '3-8',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Brown Rose'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-burgundy',
    name: 'Garlic - Burgundy',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'softneck garlic. Milder flavor, longer storage, no scapes. Plant in fall for summer harvest.',
    hardinessZones: '5-10',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Burgundy'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-cajun',
    name: 'Garlic - Cajun',
    scientificName: 'Allium ampeloprasum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 240,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'elephant garlic. Mild giant cloves, closer to leeks. Plant in fall for summer harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'fall',
    height: '3-4 feet',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Cajun'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-carpathian',
    name: 'Garlic - Carpathian',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'hardneck garlic. Cold hardy, produces scapes, complex flavor. Plant in fall for summer harvest.',
    hardinessZones: '3-8',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Carpathian'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-chopanski',
    name: 'Garlic - Chopanski',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'softneck garlic. Milder flavor, longer storage, no scapes. Plant in fall for summer harvest.',
    hardinessZones: '5-10',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Chopanski'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-corsican-red',
    name: 'Garlic - Corsican Red',
    scientificName: 'Allium ampeloprasum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 240,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'elephant garlic. Mild giant cloves, closer to leeks. Plant in fall for summer harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'fall',
    height: '3-4 feet',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Corsican Red'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-creole-red',
    name: 'Garlic - Creole Red',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'hardneck garlic. Cold hardy, produces scapes, complex flavor. Plant in fall for summer harvest.',
    hardinessZones: '3-8',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Creole Red'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-duganski',
    name: 'Garlic - Duganski',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'softneck garlic. Milder flavor, longer storage, no scapes. Plant in fall for summer harvest.',
    hardinessZones: '5-10',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Duganski'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-early-italian-purple',
    name: 'Garlic - Early Italian Purple',
    scientificName: 'Allium ampeloprasum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 240,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'elephant garlic. Mild giant cloves, closer to leeks. Plant in fall for summer harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'fall',
    height: '3-4 feet',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Early Italian Purple'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-elephant',
    name: 'Garlic - Elephant',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'hardneck garlic. Cold hardy, produces scapes, complex flavor. Plant in fall for summer harvest.',
    hardinessZones: '3-8',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Elephant'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-french-pink',
    name: 'Garlic - French Pink',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'softneck garlic. Milder flavor, longer storage, no scapes. Plant in fall for summer harvest.',
    hardinessZones: '5-10',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['French Pink'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-georgian-crystal',
    name: 'Garlic - Georgian Crystal',
    scientificName: 'Allium ampeloprasum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 240,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'elephant garlic. Mild giant cloves, closer to leeks. Plant in fall for summer harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'fall',
    height: '3-4 feet',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Georgian Crystal'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-german-giant',
    name: 'Garlic - German Giant',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'hardneck garlic. Cold hardy, produces scapes, complex flavor. Plant in fall for summer harvest.',
    hardinessZones: '3-8',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['German Giant'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-guatemalan-ikeda',
    name: 'Garlic - Guatemalan Ikeda',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'softneck garlic. Milder flavor, longer storage, no scapes. Plant in fall for summer harvest.',
    hardinessZones: '5-10',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Guatemalan Ikeda'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-hadrut',
    name: 'Garlic - Hadrut',
    scientificName: 'Allium ampeloprasum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 240,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'elephant garlic. Mild giant cloves, closer to leeks. Plant in fall for summer harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'fall',
    height: '3-4 feet',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Hadrut'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-iberian',
    name: 'Garlic - Iberian',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'hardneck garlic. Cold hardy, produces scapes, complex flavor. Plant in fall for summer harvest.',
    hardinessZones: '3-8',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Iberian'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-italian-late',
    name: 'Garlic - Italian Late',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'softneck garlic. Milder flavor, longer storage, no scapes. Plant in fall for summer harvest.',
    hardinessZones: '5-10',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Italian Late'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-khabar',
    name: 'Garlic - Khabar',
    scientificName: 'Allium ampeloprasum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 240,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'elephant garlic. Mild giant cloves, closer to leeks. Plant in fall for summer harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'fall',
    height: '3-4 feet',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Khabar'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-korean-red',
    name: 'Garlic - Korean Red',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'hardneck garlic. Cold hardy, produces scapes, complex flavor. Plant in fall for summer harvest.',
    hardinessZones: '3-8',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Korean Red'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-krasnodar-white',
    name: 'Garlic - Krasnodar White',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'softneck garlic. Milder flavor, longer storage, no scapes. Plant in fall for summer harvest.',
    hardinessZones: '5-10',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Krasnodar White'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-kyrgyz',
    name: 'Garlic - Kyrgyz',
    scientificName: 'Allium ampeloprasum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 240,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'elephant garlic. Mild giant cloves, closer to leeks. Plant in fall for summer harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'fall',
    height: '3-4 feet',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Kyrgyz'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-legacy',
    name: 'Garlic - Legacy',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'hardneck garlic. Cold hardy, produces scapes, complex flavor. Plant in fall for summer harvest.',
    hardinessZones: '3-8',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Legacy'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-leningrad',
    name: 'Garlic - Leningrad',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'softneck garlic. Milder flavor, longer storage, no scapes. Plant in fall for summer harvest.',
    hardinessZones: '5-10',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Leningrad'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-lithuanian',
    name: 'Garlic - Lithuanian',
    scientificName: 'Allium ampeloprasum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 240,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'elephant garlic. Mild giant cloves, closer to leeks. Plant in fall for summer harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'fall',
    height: '3-4 feet',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Lithuanian'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-lorz-italian',
    name: 'Garlic - Lorz Italian',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'hardneck garlic. Cold hardy, produces scapes, complex flavor. Plant in fall for summer harvest.',
    hardinessZones: '3-8',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Lorz Italian'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-majestic',
    name: 'Garlic - Majestic',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'softneck garlic. Milder flavor, longer storage, no scapes. Plant in fall for summer harvest.',
    hardinessZones: '5-10',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Majestic'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-manchurian',
    name: 'Garlic - Manchurian',
    scientificName: 'Allium ampeloprasum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 240,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'elephant garlic. Mild giant cloves, closer to leeks. Plant in fall for summer harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'fall',
    height: '3-4 feet',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Manchurian'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-marbled-purple-stripe',
    name: 'Garlic - Marbled Purple Stripe',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'hardneck garlic. Cold hardy, produces scapes, complex flavor. Plant in fall for summer harvest.',
    hardinessZones: '3-8',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Marbled Purple Stripe'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-mexican-purple',
    name: 'Garlic - Mexican Purple',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'softneck garlic. Milder flavor, longer storage, no scapes. Plant in fall for summer harvest.',
    hardinessZones: '5-10',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Mexican Purple'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-mild-french',
    name: 'Garlic - Mild French',
    scientificName: 'Allium ampeloprasum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 240,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'elephant garlic. Mild giant cloves, closer to leeks. Plant in fall for summer harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'fall',
    height: '3-4 feet',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Mild French'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-montana-giant',
    name: 'Garlic - Montana Giant',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'hardneck garlic. Cold hardy, produces scapes, complex flavor. Plant in fall for summer harvest.',
    hardinessZones: '3-8',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Montana Giant'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-mount-hood',
    name: 'Garlic - Mount Hood',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'softneck garlic. Milder flavor, longer storage, no scapes. Plant in fall for summer harvest.',
    hardinessZones: '5-10',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Mount Hood'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-nootka-rose',
    name: 'Garlic - Nootka Rose',
    scientificName: 'Allium ampeloprasum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 240,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'elephant garlic. Mild giant cloves, closer to leeks. Plant in fall for summer harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'fall',
    height: '3-4 feet',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Nootka Rose'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-oregon-white',
    name: 'Garlic - Oregon White',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'hardneck garlic. Cold hardy, produces scapes, complex flavor. Plant in fall for summer harvest.',
    hardinessZones: '3-8',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Oregon White'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-persian-brown',
    name: 'Garlic - Persian Brown',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'softneck garlic. Milder flavor, longer storage, no scapes. Plant in fall for summer harvest.',
    hardinessZones: '5-10',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Persian Brown'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-phillips',
    name: 'Garlic - Phillips',
    scientificName: 'Allium ampeloprasum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 240,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'elephant garlic. Mild giant cloves, closer to leeks. Plant in fall for summer harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'fall',
    height: '3-4 feet',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Phillips'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-pitarelli',
    name: 'Garlic - Pitarelli',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'hardneck garlic. Cold hardy, produces scapes, complex flavor. Plant in fall for summer harvest.',
    hardinessZones: '3-8',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Pitarelli'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-pskem',
    name: 'Garlic - Pskem',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'softneck garlic. Milder flavor, longer storage, no scapes. Plant in fall for summer harvest.',
    hardinessZones: '5-10',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Pskem'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-purple-italian',
    name: 'Garlic - Purple Italian',
    scientificName: 'Allium ampeloprasum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 240,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'elephant garlic. Mild giant cloves, closer to leeks. Plant in fall for summer harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'fall',
    height: '3-4 feet',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Purple Italian'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-red-janice',
    name: 'Garlic - Red Janice',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'hardneck garlic. Cold hardy, produces scapes, complex flavor. Plant in fall for summer harvest.',
    hardinessZones: '3-8',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Red Janice'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-red-rezan',
    name: 'Garlic - Red Rezan',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'softneck garlic. Milder flavor, longer storage, no scapes. Plant in fall for summer harvest.',
    hardinessZones: '5-10',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Red Rezan'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-rhapsody',
    name: 'Garlic - Rhapsody',
    scientificName: 'Allium ampeloprasum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 240,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'elephant garlic. Mild giant cloves, closer to leeks. Plant in fall for summer harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'fall',
    height: '3-4 feet',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Rhapsody'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-rosewood',
    name: 'Garlic - Rosewood',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'hardneck garlic. Cold hardy, produces scapes, complex flavor. Plant in fall for summer harvest.',
    hardinessZones: '3-8',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Rosewood'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-sakura',
    name: 'Garlic - Sakura',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'softneck garlic. Milder flavor, longer storage, no scapes. Plant in fall for summer harvest.',
    hardinessZones: '5-10',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Sakura'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-siberian',
    name: 'Garlic - Siberian',
    scientificName: 'Allium ampeloprasum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 240,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'elephant garlic. Mild giant cloves, closer to leeks. Plant in fall for summer harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'fall',
    height: '3-4 feet',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Siberian'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-simonetti',
    name: 'Garlic - Simonetti',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'hardneck garlic. Cold hardy, produces scapes, complex flavor. Plant in fall for summer harvest.',
    hardinessZones: '3-8',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Simonetti'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-skuri-1',
    name: 'Garlic - Skuri #1',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'softneck garlic. Milder flavor, longer storage, no scapes. Plant in fall for summer harvest.',
    hardinessZones: '5-10',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Skuri #1'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-slovak',
    name: 'Garlic - Slovak',
    scientificName: 'Allium ampeloprasum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 240,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'elephant garlic. Mild giant cloves, closer to leeks. Plant in fall for summer harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'fall',
    height: '3-4 feet',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Slovak'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-solent',
    name: 'Garlic - Solent',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'hardneck garlic. Cold hardy, produces scapes, complex flavor. Plant in fall for summer harvest.',
    hardinessZones: '3-8',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Solent'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-sonoran',
    name: 'Garlic - Sonoran',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'softneck garlic. Milder flavor, longer storage, no scapes. Plant in fall for summer harvest.',
    hardinessZones: '5-10',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Sonoran'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-spanish-benitee',
    name: 'Garlic - Spanish Benitee',
    scientificName: 'Allium ampeloprasum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 240,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'elephant garlic. Mild giant cloves, closer to leeks. Plant in fall for summer harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'fall',
    height: '3-4 feet',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Spanish Benitee'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-starbright',
    name: 'Garlic - Starbright',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'hardneck garlic. Cold hardy, produces scapes, complex flavor. Plant in fall for summer harvest.',
    hardinessZones: '3-8',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Starbright'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-susan-delafield',
    name: 'Garlic - Susan Delafield',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'softneck garlic. Milder flavor, longer storage, no scapes. Plant in fall for summer harvest.',
    hardinessZones: '5-10',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Susan Delafield'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-tasmanian-purple',
    name: 'Garlic - Tasmanian Purple',
    scientificName: 'Allium ampeloprasum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 240,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'elephant garlic. Mild giant cloves, closer to leeks. Plant in fall for summer harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'fall',
    height: '3-4 feet',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Tasmanian Purple'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-thermadrone',
    name: 'Garlic - Thermadrone',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'hardneck garlic. Cold hardy, produces scapes, complex flavor. Plant in fall for summer harvest.',
    hardinessZones: '3-8',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Thermadrone'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-tibetan',
    name: 'Garlic - Tibetan',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'softneck garlic. Milder flavor, longer storage, no scapes. Plant in fall for summer harvest.',
    hardinessZones: '5-10',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Tibetan'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-tochliavri',
    name: 'Garlic - Tochliavri',
    scientificName: 'Allium ampeloprasum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 240,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'elephant garlic. Mild giant cloves, closer to leeks. Plant in fall for summer harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'fall',
    height: '3-4 feet',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Tochliavri'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-turban',
    name: 'Garlic - Turban',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'hardneck garlic. Cold hardy, produces scapes, complex flavor. Plant in fall for summer harvest.',
    hardinessZones: '3-8',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Turban'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-ukrainian',
    name: 'Garlic - Ukrainian',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'softneck garlic. Milder flavor, longer storage, no scapes. Plant in fall for summer harvest.',
    hardinessZones: '5-10',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Ukrainian'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-vekak',
    name: 'Garlic - Vekak',
    scientificName: 'Allium ampeloprasum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 240,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'elephant garlic. Mild giant cloves, closer to leeks. Plant in fall for summer harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'fall',
    height: '3-4 feet',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Vekak'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-vietnamese-red',
    name: 'Garlic - Vietnamese Red',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'hardneck garlic. Cold hardy, produces scapes, complex flavor. Plant in fall for summer harvest.',
    hardinessZones: '3-8',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Vietnamese Red'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-vietnamese-purple',
    name: 'Garlic - Vietnamese Purple',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'softneck garlic. Milder flavor, longer storage, no scapes. Plant in fall for summer harvest.',
    hardinessZones: '5-10',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Vietnamese Purple'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-vostani',
    name: 'Garlic - Vostani',
    scientificName: 'Allium ampeloprasum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 240,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'elephant garlic. Mild giant cloves, closer to leeks. Plant in fall for summer harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'fall',
    height: '3-4 feet',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Vostani'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-western-rose',
    name: 'Garlic - Western Rose',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'hardneck garlic. Cold hardy, produces scapes, complex flavor. Plant in fall for summer harvest.',
    hardinessZones: '3-8',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Western Rose'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-xian',
    name: 'Garlic - Xian',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'softneck garlic. Milder flavor, longer storage, no scapes. Plant in fall for summer harvest.',
    hardinessZones: '5-10',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Xian'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-yugoslavian-red',
    name: 'Garlic - Yugoslavian Red',
    scientificName: 'Allium ampeloprasum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 240,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'elephant garlic. Mild giant cloves, closer to leeks. Plant in fall for summer harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'fall',
    height: '3-4 feet',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Yugoslavian Red'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-zemo',
    name: 'Garlic - Zemo',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'hardneck garlic. Cold hardy, produces scapes, complex flavor. Plant in fall for summer harvest.',
    hardinessZones: '3-8',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Zemo'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-zemo-garlic',
    name: 'Garlic - Zemo Garlic',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'softneck garlic. Milder flavor, longer storage, no scapes. Plant in fall for summer harvest.',
    hardinessZones: '5-10',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Zemo Garlic'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-zemo-red',
    name: 'Garlic - Zemo Red',
    scientificName: 'Allium ampeloprasum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 240,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'elephant garlic. Mild giant cloves, closer to leeks. Plant in fall for summer harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'fall',
    height: '3-4 feet',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Zemo Red'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-music-2',
    name: 'Garlic - Music 2',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'hardneck garlic. Cold hardy, produces scapes, complex flavor. Plant in fall for summer harvest.',
    hardinessZones: '3-8',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Music 2'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-german-white-2',
    name: 'Garlic - German White 2',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'softneck garlic. Milder flavor, longer storage, no scapes. Plant in fall for summer harvest.',
    hardinessZones: '5-10',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['German White 2'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-chesnok-red-2',
    name: 'Garlic - Chesnok Red 2',
    scientificName: 'Allium ampeloprasum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 240,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'elephant garlic. Mild giant cloves, closer to leeks. Plant in fall for summer harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'fall',
    height: '3-4 feet',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Chesnok Red 2'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-inchelium-red-2',
    name: 'Garlic - Inchelium Red 2',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'hardneck garlic. Cold hardy, produces scapes, complex flavor. Plant in fall for summer harvest.',
    hardinessZones: '3-8',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Inchelium Red 2'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-california-early-2',
    name: 'Garlic - California Early 2',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'softneck garlic. Milder flavor, longer storage, no scapes. Plant in fall for summer harvest.',
    hardinessZones: '5-10',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['California Early 2'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-california-late-2',
    name: 'Garlic - California Late 2',
    scientificName: 'Allium ampeloprasum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 240,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'elephant garlic. Mild giant cloves, closer to leeks. Plant in fall for summer harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'fall',
    height: '3-4 feet',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['California Late 2'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-silver-rose-2',
    name: 'Garlic - Silver Rose 2',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'hardneck garlic. Cold hardy, produces scapes, complex flavor. Plant in fall for summer harvest.',
    hardinessZones: '3-8',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Silver Rose 2'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-silver-white-2',
    name: 'Garlic - Silver White 2',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'softneck garlic. Milder flavor, longer storage, no scapes. Plant in fall for summer harvest.',
    hardinessZones: '5-10',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Silver White 2'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-transylvanian-2',
    name: 'Garlic - Transylvanian 2',
    scientificName: 'Allium ampeloprasum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 240,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'elephant garlic. Mild giant cloves, closer to leeks. Plant in fall for summer harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'fall',
    height: '3-4 feet',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Transylvanian 2'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-spanish-roja-2',
    name: 'Garlic - Spanish Roja 2',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'hardneck garlic. Cold hardy, produces scapes, complex flavor. Plant in fall for summer harvest.',
    hardinessZones: '3-8',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Spanish Roja 2'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-russian-red-2',
    name: 'Garlic - Russian Red 2',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'softneck garlic. Milder flavor, longer storage, no scapes. Plant in fall for summer harvest.',
    hardinessZones: '5-10',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Russian Red 2'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-purple-glazer-2',
    name: 'Garlic - Purple Glazer 2',
    scientificName: 'Allium ampeloprasum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 240,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'elephant garlic. Mild giant cloves, closer to leeks. Plant in fall for summer harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'fall',
    height: '3-4 feet',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Purple Glazer 2'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-persian-star-2',
    name: 'Garlic - Persian Star 2',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'hardneck garlic. Cold hardy, produces scapes, complex flavor. Plant in fall for summer harvest.',
    hardinessZones: '3-8',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Persian Star 2'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-metechi-2',
    name: 'Garlic - Metechi 2',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'softneck garlic. Milder flavor, longer storage, no scapes. Plant in fall for summer harvest.',
    hardinessZones: '5-10',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Metechi 2'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-georgian-fire-2',
    name: 'Garlic - Georgian Fire 2',
    scientificName: 'Allium ampeloprasum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 240,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'elephant garlic. Mild giant cloves, closer to leeks. Plant in fall for summer harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'fall',
    height: '3-4 feet',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Georgian Fire 2'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-romanian-red-2',
    name: 'Garlic - Romanian Red 2',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'hardneck garlic. Cold hardy, produces scapes, complex flavor. Plant in fall for summer harvest.',
    hardinessZones: '3-8',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Romanian Red 2'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-bogatyr-2',
    name: 'Garlic - Bogatyr 2',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'softneck garlic. Milder flavor, longer storage, no scapes. Plant in fall for summer harvest.',
    hardinessZones: '5-10',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Bogatyr 2'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-german-red-2',
    name: 'Garlic - German Red 2',
    scientificName: 'Allium ampeloprasum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 240,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'elephant garlic. Mild giant cloves, closer to leeks. Plant in fall for summer harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'fall',
    height: '3-4 feet',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['German Red 2'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-german-extra-hardy-2',
    name: 'Garlic - German Extra Hardy 2',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'hardneck garlic. Cold hardy, produces scapes, complex flavor. Plant in fall for summer harvest.',
    hardinessZones: '3-8',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['German Extra Hardy 2'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-polish-hardneck-2',
    name: 'Garlic - Polish Hardneck 2',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'softneck garlic. Milder flavor, longer storage, no scapes. Plant in fall for summer harvest.',
    hardinessZones: '5-10',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Polish Hardneck 2'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-yugoslavian-2',
    name: 'Garlic - Yugoslavian 2',
    scientificName: 'Allium ampeloprasum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 240,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'elephant garlic. Mild giant cloves, closer to leeks. Plant in fall for summer harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'fall',
    height: '3-4 feet',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Yugoslavian 2'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-ajo-rojo-2',
    name: 'Garlic - Ajo Rojo 2',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'hardneck garlic. Cold hardy, produces scapes, complex flavor. Plant in fall for summer harvest.',
    hardinessZones: '3-8',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Ajo Rojo 2'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-killarney-red-2',
    name: 'Garlic - Killarney Red 2',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'softneck garlic. Milder flavor, longer storage, no scapes. Plant in fall for summer harvest.',
    hardinessZones: '5-10',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Killarney Red 2'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-lorz-italian-2',
    name: 'Garlic - Lorz Italian 2',
    scientificName: 'Allium ampeloprasum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 240,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'elephant garlic. Mild giant cloves, closer to leeks. Plant in fall for summer harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'fall',
    height: '3-4 feet',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Lorz Italian 2'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-inchelium-2',
    name: 'Garlic - Inchelium 2',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'hardneck garlic. Cold hardy, produces scapes, complex flavor. Plant in fall for summer harvest.',
    hardinessZones: '3-8',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Inchelium 2'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-susanville-2',
    name: 'Garlic - Susanville 2',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'softneck garlic. Milder flavor, longer storage, no scapes. Plant in fall for summer harvest.',
    hardinessZones: '5-10',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Susanville 2'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-idaho-silver-2',
    name: 'Garlic - Idaho Silver 2',
    scientificName: 'Allium ampeloprasum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 240,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'elephant garlic. Mild giant cloves, closer to leeks. Plant in fall for summer harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'fall',
    height: '3-4 feet',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Idaho Silver 2'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-oregon-blue-2',
    name: 'Garlic - Oregon Blue 2',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'hardneck garlic. Cold hardy, produces scapes, complex flavor. Plant in fall for summer harvest.',
    hardinessZones: '3-8',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Oregon Blue 2'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-kettle-river-giant-2',
    name: 'Garlic - Kettle River Giant 2',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'softneck garlic. Milder flavor, longer storage, no scapes. Plant in fall for summer harvest.',
    hardinessZones: '5-10',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Kettle River Giant 2'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-applegate-2',
    name: 'Garlic - Applegate 2',
    scientificName: 'Allium ampeloprasum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 240,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'elephant garlic. Mild giant cloves, closer to leeks. Plant in fall for summer harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'fall',
    height: '3-4 feet',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Applegate 2'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-asian-tempest-2',
    name: 'Garlic - Asian Tempest 2',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'hardneck garlic. Cold hardy, produces scapes, complex flavor. Plant in fall for summer harvest.',
    hardinessZones: '3-8',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Asian Tempest 2'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-basque-2',
    name: 'Garlic - Basque 2',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'softneck garlic. Milder flavor, longer storage, no scapes. Plant in fall for summer harvest.',
    hardinessZones: '5-10',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Basque 2'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-belarus-2',
    name: 'Garlic - Belarus 2',
    scientificName: 'Allium ampeloprasum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 240,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'elephant garlic. Mild giant cloves, closer to leeks. Plant in fall for summer harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'fall',
    height: '3-4 feet',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Belarus 2'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-brown-rose-2',
    name: 'Garlic - Brown Rose 2',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'hardneck garlic. Cold hardy, produces scapes, complex flavor. Plant in fall for summer harvest.',
    hardinessZones: '3-8',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Brown Rose 2'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-burgundy-2',
    name: 'Garlic - Burgundy 2',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'softneck garlic. Milder flavor, longer storage, no scapes. Plant in fall for summer harvest.',
    hardinessZones: '5-10',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Burgundy 2'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-cajun-2',
    name: 'Garlic - Cajun 2',
    scientificName: 'Allium ampeloprasum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 240,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'elephant garlic. Mild giant cloves, closer to leeks. Plant in fall for summer harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'fall',
    height: '3-4 feet',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Cajun 2'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-carpathian-2',
    name: 'Garlic - Carpathian 2',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'hardneck garlic. Cold hardy, produces scapes, complex flavor. Plant in fall for summer harvest.',
    hardinessZones: '3-8',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Carpathian 2'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-chopanski-2',
    name: 'Garlic - Chopanski 2',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'softneck garlic. Milder flavor, longer storage, no scapes. Plant in fall for summer harvest.',
    hardinessZones: '5-10',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Chopanski 2'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-corsican-red-2',
    name: 'Garlic - Corsican Red 2',
    scientificName: 'Allium ampeloprasum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 240,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'elephant garlic. Mild giant cloves, closer to leeks. Plant in fall for summer harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'fall',
    height: '3-4 feet',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Corsican Red 2'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-creole-red-2',
    name: 'Garlic - Creole Red 2',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'hardneck garlic. Cold hardy, produces scapes, complex flavor. Plant in fall for summer harvest.',
    hardinessZones: '3-8',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Creole Red 2'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-duganski-2',
    name: 'Garlic - Duganski 2',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'softneck garlic. Milder flavor, longer storage, no scapes. Plant in fall for summer harvest.',
    hardinessZones: '5-10',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Duganski 2'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-early-italian-purple-2',
    name: 'Garlic - Early Italian Purple 2',
    scientificName: 'Allium ampeloprasum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 240,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'elephant garlic. Mild giant cloves, closer to leeks. Plant in fall for summer harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'fall',
    height: '3-4 feet',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Early Italian Purple 2'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-elephant-2',
    name: 'Garlic - Elephant 2',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'hardneck garlic. Cold hardy, produces scapes, complex flavor. Plant in fall for summer harvest.',
    hardinessZones: '3-8',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Elephant 2'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-french-pink-2',
    name: 'Garlic - French Pink 2',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'softneck garlic. Milder flavor, longer storage, no scapes. Plant in fall for summer harvest.',
    hardinessZones: '5-10',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['French Pink 2'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-georgian-crystal-2',
    name: 'Garlic - Georgian Crystal 2',
    scientificName: 'Allium ampeloprasum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 240,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'elephant garlic. Mild giant cloves, closer to leeks. Plant in fall for summer harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'fall',
    height: '3-4 feet',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Georgian Crystal 2'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-german-giant-2',
    name: 'Garlic - German Giant 2',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'hardneck garlic. Cold hardy, produces scapes, complex flavor. Plant in fall for summer harvest.',
    hardinessZones: '3-8',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['German Giant 2'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-guatemalan-ikeda-2',
    name: 'Garlic - Guatemalan Ikeda 2',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'softneck garlic. Milder flavor, longer storage, no scapes. Plant in fall for summer harvest.',
    hardinessZones: '5-10',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Guatemalan Ikeda 2'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-hadrut-2',
    name: 'Garlic - Hadrut 2',
    scientificName: 'Allium ampeloprasum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 240,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'elephant garlic. Mild giant cloves, closer to leeks. Plant in fall for summer harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'fall',
    height: '3-4 feet',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Hadrut 2'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-iberian-2',
    name: 'Garlic - Iberian 2',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'hardneck garlic. Cold hardy, produces scapes, complex flavor. Plant in fall for summer harvest.',
    hardinessZones: '3-8',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Iberian 2'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-italian-late-2',
    name: 'Garlic - Italian Late 2',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'softneck garlic. Milder flavor, longer storage, no scapes. Plant in fall for summer harvest.',
    hardinessZones: '5-10',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Italian Late 2'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-khabar-2',
    name: 'Garlic - Khabar 2',
    scientificName: 'Allium ampeloprasum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 240,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'elephant garlic. Mild giant cloves, closer to leeks. Plant in fall for summer harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'fall',
    height: '3-4 feet',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Khabar 2'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-korean-red-2',
    name: 'Garlic - Korean Red 2',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'hardneck garlic. Cold hardy, produces scapes, complex flavor. Plant in fall for summer harvest.',
    hardinessZones: '3-8',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Korean Red 2'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-krasnodar-white-2',
    name: 'Garlic - Krasnodar White 2',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'softneck garlic. Milder flavor, longer storage, no scapes. Plant in fall for summer harvest.',
    hardinessZones: '5-10',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Krasnodar White 2'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-kyrgyz-2',
    name: 'Garlic - Kyrgyz 2',
    scientificName: 'Allium ampeloprasum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 240,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'elephant garlic. Mild giant cloves, closer to leeks. Plant in fall for summer harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'fall',
    height: '3-4 feet',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Kyrgyz 2'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-legacy-2',
    name: 'Garlic - Legacy 2',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'hardneck garlic. Cold hardy, produces scapes, complex flavor. Plant in fall for summer harvest.',
    hardinessZones: '3-8',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Legacy 2'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-leningrad-2',
    name: 'Garlic - Leningrad 2',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'softneck garlic. Milder flavor, longer storage, no scapes. Plant in fall for summer harvest.',
    hardinessZones: '5-10',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Leningrad 2'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-lithuanian-2',
    name: 'Garlic - Lithuanian 2',
    scientificName: 'Allium ampeloprasum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 240,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'elephant garlic. Mild giant cloves, closer to leeks. Plant in fall for summer harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'fall',
    height: '3-4 feet',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Lithuanian 2'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-lorz-italian-2',
    name: 'Garlic - Lorz Italian 2',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'hardneck garlic. Cold hardy, produces scapes, complex flavor. Plant in fall for summer harvest.',
    hardinessZones: '3-8',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Lorz Italian 2'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-majestic-2',
    name: 'Garlic - Majestic 2',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'softneck garlic. Milder flavor, longer storage, no scapes. Plant in fall for summer harvest.',
    hardinessZones: '5-10',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Majestic 2'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-manchurian-2',
    name: 'Garlic - Manchurian 2',
    scientificName: 'Allium ampeloprasum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 240,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'elephant garlic. Mild giant cloves, closer to leeks. Plant in fall for summer harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'fall',
    height: '3-4 feet',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Manchurian 2'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-marbled-purple-stripe-2',
    name: 'Garlic - Marbled Purple Stripe 2',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'hardneck garlic. Cold hardy, produces scapes, complex flavor. Plant in fall for summer harvest.',
    hardinessZones: '3-8',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Marbled Purple Stripe 2'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-mexican-purple-2',
    name: 'Garlic - Mexican Purple 2',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'softneck garlic. Milder flavor, longer storage, no scapes. Plant in fall for summer harvest.',
    hardinessZones: '5-10',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Mexican Purple 2'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-mild-french-2',
    name: 'Garlic - Mild French 2',
    scientificName: 'Allium ampeloprasum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 240,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'elephant garlic. Mild giant cloves, closer to leeks. Plant in fall for summer harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'fall',
    height: '3-4 feet',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Mild French 2'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-montana-giant-2',
    name: 'Garlic - Montana Giant 2',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'hardneck garlic. Cold hardy, produces scapes, complex flavor. Plant in fall for summer harvest.',
    hardinessZones: '3-8',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Montana Giant 2'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-mount-hood-2',
    name: 'Garlic - Mount Hood 2',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'softneck garlic. Milder flavor, longer storage, no scapes. Plant in fall for summer harvest.',
    hardinessZones: '5-10',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Mount Hood 2'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-nootka-rose-2',
    name: 'Garlic - Nootka Rose 2',
    scientificName: 'Allium ampeloprasum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 240,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'elephant garlic. Mild giant cloves, closer to leeks. Plant in fall for summer harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'fall',
    height: '3-4 feet',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Nootka Rose 2'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-oregon-white-2',
    name: 'Garlic - Oregon White 2',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'hardneck garlic. Cold hardy, produces scapes, complex flavor. Plant in fall for summer harvest.',
    hardinessZones: '3-8',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Oregon White 2'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-persian-brown-2',
    name: 'Garlic - Persian Brown 2',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'softneck garlic. Milder flavor, longer storage, no scapes. Plant in fall for summer harvest.',
    hardinessZones: '5-10',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Persian Brown 2'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-phillips-2',
    name: 'Garlic - Phillips 2',
    scientificName: 'Allium ampeloprasum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 240,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'elephant garlic. Mild giant cloves, closer to leeks. Plant in fall for summer harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'fall',
    height: '3-4 feet',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Phillips 2'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-pitarelli-2',
    name: 'Garlic - Pitarelli 2',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'hardneck garlic. Cold hardy, produces scapes, complex flavor. Plant in fall for summer harvest.',
    hardinessZones: '3-8',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Pitarelli 2'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-pskem-2',
    name: 'Garlic - Pskem 2',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'softneck garlic. Milder flavor, longer storage, no scapes. Plant in fall for summer harvest.',
    hardinessZones: '5-10',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Pskem 2'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-purple-italian-2',
    name: 'Garlic - Purple Italian 2',
    scientificName: 'Allium ampeloprasum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 240,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'elephant garlic. Mild giant cloves, closer to leeks. Plant in fall for summer harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'fall',
    height: '3-4 feet',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Purple Italian 2'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-red-janice-2',
    name: 'Garlic - Red Janice 2',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'hardneck garlic. Cold hardy, produces scapes, complex flavor. Plant in fall for summer harvest.',
    hardinessZones: '3-8',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Red Janice 2'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-red-rezan-2',
    name: 'Garlic - Red Rezan 2',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'softneck garlic. Milder flavor, longer storage, no scapes. Plant in fall for summer harvest.',
    hardinessZones: '5-10',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Red Rezan 2'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-rhapsody-2',
    name: 'Garlic - Rhapsody 2',
    scientificName: 'Allium ampeloprasum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 240,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'elephant garlic. Mild giant cloves, closer to leeks. Plant in fall for summer harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'fall',
    height: '3-4 feet',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Rhapsody 2'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-rosewood-2',
    name: 'Garlic - Rosewood 2',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'hardneck garlic. Cold hardy, produces scapes, complex flavor. Plant in fall for summer harvest.',
    hardinessZones: '3-8',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Rosewood 2'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-sakura-2',
    name: 'Garlic - Sakura 2',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'softneck garlic. Milder flavor, longer storage, no scapes. Plant in fall for summer harvest.',
    hardinessZones: '5-10',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Sakura 2'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-siberian-2',
    name: 'Garlic - Siberian 2',
    scientificName: 'Allium ampeloprasum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 240,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'elephant garlic. Mild giant cloves, closer to leeks. Plant in fall for summer harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'fall',
    height: '3-4 feet',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Siberian 2'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-simonetti-2',
    name: 'Garlic - Simonetti 2',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'hardneck garlic. Cold hardy, produces scapes, complex flavor. Plant in fall for summer harvest.',
    hardinessZones: '3-8',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Simonetti 2'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-skuri-1-2',
    name: 'Garlic - Skuri #1 2',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'softneck garlic. Milder flavor, longer storage, no scapes. Plant in fall for summer harvest.',
    hardinessZones: '5-10',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Skuri #1 2'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-slovak-2',
    name: 'Garlic - Slovak 2',
    scientificName: 'Allium ampeloprasum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 240,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'elephant garlic. Mild giant cloves, closer to leeks. Plant in fall for summer harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'fall',
    height: '3-4 feet',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Slovak 2'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-solent-2',
    name: 'Garlic - Solent 2',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'hardneck garlic. Cold hardy, produces scapes, complex flavor. Plant in fall for summer harvest.',
    hardinessZones: '3-8',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Solent 2'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-sonoran-2',
    name: 'Garlic - Sonoran 2',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'softneck garlic. Milder flavor, longer storage, no scapes. Plant in fall for summer harvest.',
    hardinessZones: '5-10',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Sonoran 2'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-spanish-benitee-2',
    name: 'Garlic - Spanish Benitee 2',
    scientificName: 'Allium ampeloprasum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 240,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'elephant garlic. Mild giant cloves, closer to leeks. Plant in fall for summer harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'fall',
    height: '3-4 feet',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Spanish Benitee 2'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-starbright-2',
    name: 'Garlic - Starbright 2',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'hardneck garlic. Cold hardy, produces scapes, complex flavor. Plant in fall for summer harvest.',
    hardinessZones: '3-8',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Starbright 2'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-susan-delafield-2',
    name: 'Garlic - Susan Delafield 2',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'softneck garlic. Milder flavor, longer storage, no scapes. Plant in fall for summer harvest.',
    hardinessZones: '5-10',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Susan Delafield 2'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-tasmanian-purple-2',
    name: 'Garlic - Tasmanian Purple 2',
    scientificName: 'Allium ampeloprasum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 240,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'elephant garlic. Mild giant cloves, closer to leeks. Plant in fall for summer harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'fall',
    height: '3-4 feet',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Tasmanian Purple 2'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-thermadrone-2',
    name: 'Garlic - Thermadrone 2',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'hardneck garlic. Cold hardy, produces scapes, complex flavor. Plant in fall for summer harvest.',
    hardinessZones: '3-8',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Thermadrone 2'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-tibetan-2',
    name: 'Garlic - Tibetan 2',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'softneck garlic. Milder flavor, longer storage, no scapes. Plant in fall for summer harvest.',
    hardinessZones: '5-10',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Tibetan 2'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-tochliavri-2',
    name: 'Garlic - Tochliavri 2',
    scientificName: 'Allium ampeloprasum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 240,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'elephant garlic. Mild giant cloves, closer to leeks. Plant in fall for summer harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'fall',
    height: '3-4 feet',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Tochliavri 2'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-turban-2',
    name: 'Garlic - Turban 2',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'hardneck garlic. Cold hardy, produces scapes, complex flavor. Plant in fall for summer harvest.',
    hardinessZones: '3-8',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Turban 2'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-ukrainian-2',
    name: 'Garlic - Ukrainian 2',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'softneck garlic. Milder flavor, longer storage, no scapes. Plant in fall for summer harvest.',
    hardinessZones: '5-10',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Ukrainian 2'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-vekak-2',
    name: 'Garlic - Vekak 2',
    scientificName: 'Allium ampeloprasum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 240,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'elephant garlic. Mild giant cloves, closer to leeks. Plant in fall for summer harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'fall',
    height: '3-4 feet',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Vekak 2'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-vietnamese-red-2',
    name: 'Garlic - Vietnamese Red 2',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'hardneck garlic. Cold hardy, produces scapes, complex flavor. Plant in fall for summer harvest.',
    hardinessZones: '3-8',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Vietnamese Red 2'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-vietnamese-purple-2',
    name: 'Garlic - Vietnamese Purple 2',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'softneck garlic. Milder flavor, longer storage, no scapes. Plant in fall for summer harvest.',
    hardinessZones: '5-10',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Vietnamese Purple 2'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-vostani-2',
    name: 'Garlic - Vostani 2',
    scientificName: 'Allium ampeloprasum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 240,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'elephant garlic. Mild giant cloves, closer to leeks. Plant in fall for summer harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'fall',
    height: '3-4 feet',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Vostani 2'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-western-rose-2',
    name: 'Garlic - Western Rose 2',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'hardneck garlic. Cold hardy, produces scapes, complex flavor. Plant in fall for summer harvest.',
    hardinessZones: '3-8',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Western Rose 2'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-xian-2',
    name: 'Garlic - Xian 2',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'softneck garlic. Milder flavor, longer storage, no scapes. Plant in fall for summer harvest.',
    hardinessZones: '5-10',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Xian 2'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-yugoslavian-red-2',
    name: 'Garlic - Yugoslavian Red 2',
    scientificName: 'Allium ampeloprasum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 240,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'elephant garlic. Mild giant cloves, closer to leeks. Plant in fall for summer harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'fall',
    height: '3-4 feet',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Yugoslavian Red 2'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-zemo-2',
    name: 'Garlic - Zemo 2',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'hardneck garlic. Cold hardy, produces scapes, complex flavor. Plant in fall for summer harvest.',
    hardinessZones: '3-8',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Zemo 2'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-zemo-garlic-2',
    name: 'Garlic - Zemo Garlic 2',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'softneck garlic. Milder flavor, longer storage, no scapes. Plant in fall for summer harvest.',
    hardinessZones: '5-10',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Zemo Garlic 2'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-zemo-red-2',
    name: 'Garlic - Zemo Red 2',
    scientificName: 'Allium ampeloprasum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 240,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'elephant garlic. Mild giant cloves, closer to leeks. Plant in fall for summer harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'fall',
    height: '3-4 feet',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Zemo Red 2'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-music-3',
    name: 'Garlic - Music 3',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'hardneck garlic. Cold hardy, produces scapes, complex flavor. Plant in fall for summer harvest.',
    hardinessZones: '3-8',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Music 3'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-german-white-3',
    name: 'Garlic - German White 3',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'softneck garlic. Milder flavor, longer storage, no scapes. Plant in fall for summer harvest.',
    hardinessZones: '5-10',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['German White 3'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-chesnok-red-3',
    name: 'Garlic - Chesnok Red 3',
    scientificName: 'Allium ampeloprasum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 240,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'elephant garlic. Mild giant cloves, closer to leeks. Plant in fall for summer harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'fall',
    height: '3-4 feet',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Chesnok Red 3'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-inchelium-red-3',
    name: 'Garlic - Inchelium Red 3',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'hardneck garlic. Cold hardy, produces scapes, complex flavor. Plant in fall for summer harvest.',
    hardinessZones: '3-8',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Inchelium Red 3'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-california-early-3',
    name: 'Garlic - California Early 3',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'softneck garlic. Milder flavor, longer storage, no scapes. Plant in fall for summer harvest.',
    hardinessZones: '5-10',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['California Early 3'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-california-late-3',
    name: 'Garlic - California Late 3',
    scientificName: 'Allium ampeloprasum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 240,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'elephant garlic. Mild giant cloves, closer to leeks. Plant in fall for summer harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'fall',
    height: '3-4 feet',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['California Late 3'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-silver-rose-3',
    name: 'Garlic - Silver Rose 3',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'hardneck garlic. Cold hardy, produces scapes, complex flavor. Plant in fall for summer harvest.',
    hardinessZones: '3-8',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Silver Rose 3'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-silver-white-3',
    name: 'Garlic - Silver White 3',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'softneck garlic. Milder flavor, longer storage, no scapes. Plant in fall for summer harvest.',
    hardinessZones: '5-10',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Silver White 3'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-transylvanian-3',
    name: 'Garlic - Transylvanian 3',
    scientificName: 'Allium ampeloprasum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 240,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'elephant garlic. Mild giant cloves, closer to leeks. Plant in fall for summer harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'fall',
    height: '3-4 feet',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Transylvanian 3'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-spanish-roja-3',
    name: 'Garlic - Spanish Roja 3',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'hardneck garlic. Cold hardy, produces scapes, complex flavor. Plant in fall for summer harvest.',
    hardinessZones: '3-8',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Spanish Roja 3'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-russian-red-3',
    name: 'Garlic - Russian Red 3',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'softneck garlic. Milder flavor, longer storage, no scapes. Plant in fall for summer harvest.',
    hardinessZones: '5-10',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Russian Red 3'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-purple-glazer-3',
    name: 'Garlic - Purple Glazer 3',
    scientificName: 'Allium ampeloprasum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 240,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'elephant garlic. Mild giant cloves, closer to leeks. Plant in fall for summer harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'fall',
    height: '3-4 feet',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Purple Glazer 3'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-persian-star-3',
    name: 'Garlic - Persian Star 3',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'hardneck garlic. Cold hardy, produces scapes, complex flavor. Plant in fall for summer harvest.',
    hardinessZones: '3-8',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Persian Star 3'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-metechi-3',
    name: 'Garlic - Metechi 3',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'softneck garlic. Milder flavor, longer storage, no scapes. Plant in fall for summer harvest.',
    hardinessZones: '5-10',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Metechi 3'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-georgian-fire-3',
    name: 'Garlic - Georgian Fire 3',
    scientificName: 'Allium ampeloprasum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 240,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'elephant garlic. Mild giant cloves, closer to leeks. Plant in fall for summer harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'fall',
    height: '3-4 feet',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Georgian Fire 3'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-romanian-red-3',
    name: 'Garlic - Romanian Red 3',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'hardneck garlic. Cold hardy, produces scapes, complex flavor. Plant in fall for summer harvest.',
    hardinessZones: '3-8',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Romanian Red 3'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-bogatyr-3',
    name: 'Garlic - Bogatyr 3',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'softneck garlic. Milder flavor, longer storage, no scapes. Plant in fall for summer harvest.',
    hardinessZones: '5-10',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Bogatyr 3'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-german-red-3',
    name: 'Garlic - German Red 3',
    scientificName: 'Allium ampeloprasum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 240,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'elephant garlic. Mild giant cloves, closer to leeks. Plant in fall for summer harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'fall',
    height: '3-4 feet',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['German Red 3'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-german-extra-hardy-3',
    name: 'Garlic - German Extra Hardy 3',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'hardneck garlic. Cold hardy, produces scapes, complex flavor. Plant in fall for summer harvest.',
    hardinessZones: '3-8',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['German Extra Hardy 3'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-polish-hardneck-3',
    name: 'Garlic - Polish Hardneck 3',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'softneck garlic. Milder flavor, longer storage, no scapes. Plant in fall for summer harvest.',
    hardinessZones: '5-10',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Polish Hardneck 3'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-yugoslavian-3',
    name: 'Garlic - Yugoslavian 3',
    scientificName: 'Allium ampeloprasum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 240,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'elephant garlic. Mild giant cloves, closer to leeks. Plant in fall for summer harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'fall',
    height: '3-4 feet',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Yugoslavian 3'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-ajo-rojo-3',
    name: 'Garlic - Ajo Rojo 3',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'hardneck garlic. Cold hardy, produces scapes, complex flavor. Plant in fall for summer harvest.',
    hardinessZones: '3-8',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Ajo Rojo 3'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-killarney-red-3',
    name: 'Garlic - Killarney Red 3',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'softneck garlic. Milder flavor, longer storage, no scapes. Plant in fall for summer harvest.',
    hardinessZones: '5-10',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Killarney Red 3'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-lorz-italian-3',
    name: 'Garlic - Lorz Italian 3',
    scientificName: 'Allium ampeloprasum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 240,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'elephant garlic. Mild giant cloves, closer to leeks. Plant in fall for summer harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'fall',
    height: '3-4 feet',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Lorz Italian 3'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-inchelium-3',
    name: 'Garlic - Inchelium 3',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'hardneck garlic. Cold hardy, produces scapes, complex flavor. Plant in fall for summer harvest.',
    hardinessZones: '3-8',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Inchelium 3'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-susanville-3',
    name: 'Garlic - Susanville 3',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'softneck garlic. Milder flavor, longer storage, no scapes. Plant in fall for summer harvest.',
    hardinessZones: '5-10',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Susanville 3'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-idaho-silver-3',
    name: 'Garlic - Idaho Silver 3',
    scientificName: 'Allium ampeloprasum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 240,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'elephant garlic. Mild giant cloves, closer to leeks. Plant in fall for summer harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'fall',
    height: '3-4 feet',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Idaho Silver 3'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-oregon-blue-3',
    name: 'Garlic - Oregon Blue 3',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'hardneck garlic. Cold hardy, produces scapes, complex flavor. Plant in fall for summer harvest.',
    hardinessZones: '3-8',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Oregon Blue 3'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-kettle-river-giant-3',
    name: 'Garlic - Kettle River Giant 3',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'softneck garlic. Milder flavor, longer storage, no scapes. Plant in fall for summer harvest.',
    hardinessZones: '5-10',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Kettle River Giant 3'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-applegate-3',
    name: 'Garlic - Applegate 3',
    scientificName: 'Allium ampeloprasum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 240,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'elephant garlic. Mild giant cloves, closer to leeks. Plant in fall for summer harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'fall',
    height: '3-4 feet',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Applegate 3'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-asian-tempest-3',
    name: 'Garlic - Asian Tempest 3',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'hardneck garlic. Cold hardy, produces scapes, complex flavor. Plant in fall for summer harvest.',
    hardinessZones: '3-8',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Asian Tempest 3'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-basque-3',
    name: 'Garlic - Basque 3',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'softneck garlic. Milder flavor, longer storage, no scapes. Plant in fall for summer harvest.',
    hardinessZones: '5-10',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Basque 3'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-belarus-3',
    name: 'Garlic - Belarus 3',
    scientificName: 'Allium ampeloprasum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 240,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'elephant garlic. Mild giant cloves, closer to leeks. Plant in fall for summer harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'fall',
    height: '3-4 feet',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Belarus 3'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-brown-rose-3',
    name: 'Garlic - Brown Rose 3',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'hardneck garlic. Cold hardy, produces scapes, complex flavor. Plant in fall for summer harvest.',
    hardinessZones: '3-8',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Brown Rose 3'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-burgundy-3',
    name: 'Garlic - Burgundy 3',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'softneck garlic. Milder flavor, longer storage, no scapes. Plant in fall for summer harvest.',
    hardinessZones: '5-10',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Burgundy 3'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-cajun-3',
    name: 'Garlic - Cajun 3',
    scientificName: 'Allium ampeloprasum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 240,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'elephant garlic. Mild giant cloves, closer to leeks. Plant in fall for summer harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'fall',
    height: '3-4 feet',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Cajun 3'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-carpathian-3',
    name: 'Garlic - Carpathian 3',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'hardneck garlic. Cold hardy, produces scapes, complex flavor. Plant in fall for summer harvest.',
    hardinessZones: '3-8',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Carpathian 3'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-chopanski-3',
    name: 'Garlic - Chopanski 3',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'softneck garlic. Milder flavor, longer storage, no scapes. Plant in fall for summer harvest.',
    hardinessZones: '5-10',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Chopanski 3'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-corsican-red-3',
    name: 'Garlic - Corsican Red 3',
    scientificName: 'Allium ampeloprasum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 240,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'elephant garlic. Mild giant cloves, closer to leeks. Plant in fall for summer harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'fall',
    height: '3-4 feet',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Corsican Red 3'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-creole-red-3',
    name: 'Garlic - Creole Red 3',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'hardneck garlic. Cold hardy, produces scapes, complex flavor. Plant in fall for summer harvest.',
    hardinessZones: '3-8',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Creole Red 3'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-duganski-3',
    name: 'Garlic - Duganski 3',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'softneck garlic. Milder flavor, longer storage, no scapes. Plant in fall for summer harvest.',
    hardinessZones: '5-10',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Duganski 3'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-early-italian-purple-3',
    name: 'Garlic - Early Italian Purple 3',
    scientificName: 'Allium ampeloprasum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 240,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'elephant garlic. Mild giant cloves, closer to leeks. Plant in fall for summer harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'fall',
    height: '3-4 feet',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Early Italian Purple 3'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-elephant-3',
    name: 'Garlic - Elephant 3',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'hardneck garlic. Cold hardy, produces scapes, complex flavor. Plant in fall for summer harvest.',
    hardinessZones: '3-8',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Elephant 3'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-french-pink-3',
    name: 'Garlic - French Pink 3',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'softneck garlic. Milder flavor, longer storage, no scapes. Plant in fall for summer harvest.',
    hardinessZones: '5-10',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['French Pink 3'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-georgian-crystal-3',
    name: 'Garlic - Georgian Crystal 3',
    scientificName: 'Allium ampeloprasum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 240,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'elephant garlic. Mild giant cloves, closer to leeks. Plant in fall for summer harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'fall',
    height: '3-4 feet',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Georgian Crystal 3'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-german-giant-3',
    name: 'Garlic - German Giant 3',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'hardneck garlic. Cold hardy, produces scapes, complex flavor. Plant in fall for summer harvest.',
    hardinessZones: '3-8',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['German Giant 3'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-guatemalan-ikeda-3',
    name: 'Garlic - Guatemalan Ikeda 3',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'softneck garlic. Milder flavor, longer storage, no scapes. Plant in fall for summer harvest.',
    hardinessZones: '5-10',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Guatemalan Ikeda 3'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-hadrut-3',
    name: 'Garlic - Hadrut 3',
    scientificName: 'Allium ampeloprasum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 240,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'elephant garlic. Mild giant cloves, closer to leeks. Plant in fall for summer harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'fall',
    height: '3-4 feet',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Hadrut 3'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-iberian-3',
    name: 'Garlic - Iberian 3',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'hardneck garlic. Cold hardy, produces scapes, complex flavor. Plant in fall for summer harvest.',
    hardinessZones: '3-8',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Iberian 3'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-italian-late-3',
    name: 'Garlic - Italian Late 3',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'softneck garlic. Milder flavor, longer storage, no scapes. Plant in fall for summer harvest.',
    hardinessZones: '5-10',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Italian Late 3'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-khabar-3',
    name: 'Garlic - Khabar 3',
    scientificName: 'Allium ampeloprasum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 240,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'elephant garlic. Mild giant cloves, closer to leeks. Plant in fall for summer harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'fall',
    height: '3-4 feet',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Khabar 3'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-korean-red-3',
    name: 'Garlic - Korean Red 3',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'hardneck garlic. Cold hardy, produces scapes, complex flavor. Plant in fall for summer harvest.',
    hardinessZones: '3-8',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Korean Red 3'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-krasnodar-white-3',
    name: 'Garlic - Krasnodar White 3',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'softneck garlic. Milder flavor, longer storage, no scapes. Plant in fall for summer harvest.',
    hardinessZones: '5-10',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Krasnodar White 3'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-kyrgyz-3',
    name: 'Garlic - Kyrgyz 3',
    scientificName: 'Allium ampeloprasum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 240,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'elephant garlic. Mild giant cloves, closer to leeks. Plant in fall for summer harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'fall',
    height: '3-4 feet',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Kyrgyz 3'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-legacy-3',
    name: 'Garlic - Legacy 3',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'hardneck garlic. Cold hardy, produces scapes, complex flavor. Plant in fall for summer harvest.',
    hardinessZones: '3-8',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Legacy 3'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-leningrad-3',
    name: 'Garlic - Leningrad 3',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'softneck garlic. Milder flavor, longer storage, no scapes. Plant in fall for summer harvest.',
    hardinessZones: '5-10',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Leningrad 3'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-lithuanian-3',
    name: 'Garlic - Lithuanian 3',
    scientificName: 'Allium ampeloprasum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 240,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'elephant garlic. Mild giant cloves, closer to leeks. Plant in fall for summer harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'fall',
    height: '3-4 feet',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Lithuanian 3'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-lorz-italian-3',
    name: 'Garlic - Lorz Italian 3',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'hardneck garlic. Cold hardy, produces scapes, complex flavor. Plant in fall for summer harvest.',
    hardinessZones: '3-8',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Lorz Italian 3'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-majestic-3',
    name: 'Garlic - Majestic 3',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'softneck garlic. Milder flavor, longer storage, no scapes. Plant in fall for summer harvest.',
    hardinessZones: '5-10',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Majestic 3'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-manchurian-3',
    name: 'Garlic - Manchurian 3',
    scientificName: 'Allium ampeloprasum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 240,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'elephant garlic. Mild giant cloves, closer to leeks. Plant in fall for summer harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'fall',
    height: '3-4 feet',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Manchurian 3'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-marbled-purple-stripe-3',
    name: 'Garlic - Marbled Purple Stripe 3',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'hardneck garlic. Cold hardy, produces scapes, complex flavor. Plant in fall for summer harvest.',
    hardinessZones: '3-8',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Marbled Purple Stripe 3'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-mexican-purple-3',
    name: 'Garlic - Mexican Purple 3',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'softneck garlic. Milder flavor, longer storage, no scapes. Plant in fall for summer harvest.',
    hardinessZones: '5-10',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Mexican Purple 3'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-mild-french-3',
    name: 'Garlic - Mild French 3',
    scientificName: 'Allium ampeloprasum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 240,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'elephant garlic. Mild giant cloves, closer to leeks. Plant in fall for summer harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'fall',
    height: '3-4 feet',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Mild French 3'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-montana-giant-3',
    name: 'Garlic - Montana Giant 3',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'hardneck garlic. Cold hardy, produces scapes, complex flavor. Plant in fall for summer harvest.',
    hardinessZones: '3-8',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Montana Giant 3'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-mount-hood-3',
    name: 'Garlic - Mount Hood 3',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'softneck garlic. Milder flavor, longer storage, no scapes. Plant in fall for summer harvest.',
    hardinessZones: '5-10',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Mount Hood 3'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-nootka-rose-3',
    name: 'Garlic - Nootka Rose 3',
    scientificName: 'Allium ampeloprasum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 240,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'elephant garlic. Mild giant cloves, closer to leeks. Plant in fall for summer harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'fall',
    height: '3-4 feet',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Nootka Rose 3'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-oregon-white-3',
    name: 'Garlic - Oregon White 3',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'hardneck garlic. Cold hardy, produces scapes, complex flavor. Plant in fall for summer harvest.',
    hardinessZones: '3-8',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Oregon White 3'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-persian-brown-3',
    name: 'Garlic - Persian Brown 3',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'softneck garlic. Milder flavor, longer storage, no scapes. Plant in fall for summer harvest.',
    hardinessZones: '5-10',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Persian Brown 3'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-phillips-3',
    name: 'Garlic - Phillips 3',
    scientificName: 'Allium ampeloprasum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 240,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'elephant garlic. Mild giant cloves, closer to leeks. Plant in fall for summer harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'fall',
    height: '3-4 feet',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Phillips 3'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-pitarelli-3',
    name: 'Garlic - Pitarelli 3',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'hardneck garlic. Cold hardy, produces scapes, complex flavor. Plant in fall for summer harvest.',
    hardinessZones: '3-8',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Pitarelli 3'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-pskem-3',
    name: 'Garlic - Pskem 3',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'softneck garlic. Milder flavor, longer storage, no scapes. Plant in fall for summer harvest.',
    hardinessZones: '5-10',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Pskem 3'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-purple-italian-3',
    name: 'Garlic - Purple Italian 3',
    scientificName: 'Allium ampeloprasum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 240,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'elephant garlic. Mild giant cloves, closer to leeks. Plant in fall for summer harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'fall',
    height: '3-4 feet',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Purple Italian 3'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-red-janice-3',
    name: 'Garlic - Red Janice 3',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'hardneck garlic. Cold hardy, produces scapes, complex flavor. Plant in fall for summer harvest.',
    hardinessZones: '3-8',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Red Janice 3'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-red-rezan-3',
    name: 'Garlic - Red Rezan 3',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'softneck garlic. Milder flavor, longer storage, no scapes. Plant in fall for summer harvest.',
    hardinessZones: '5-10',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Red Rezan 3'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-rhapsody-3',
    name: 'Garlic - Rhapsody 3',
    scientificName: 'Allium ampeloprasum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 240,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'elephant garlic. Mild giant cloves, closer to leeks. Plant in fall for summer harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'fall',
    height: '3-4 feet',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Rhapsody 3'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-rosewood-3',
    name: 'Garlic - Rosewood 3',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'hardneck garlic. Cold hardy, produces scapes, complex flavor. Plant in fall for summer harvest.',
    hardinessZones: '3-8',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Rosewood 3'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-sakura-3',
    name: 'Garlic - Sakura 3',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'softneck garlic. Milder flavor, longer storage, no scapes. Plant in fall for summer harvest.',
    hardinessZones: '5-10',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Sakura 3'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-siberian-3',
    name: 'Garlic - Siberian 3',
    scientificName: 'Allium ampeloprasum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 240,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'elephant garlic. Mild giant cloves, closer to leeks. Plant in fall for summer harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'fall',
    height: '3-4 feet',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Siberian 3'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-simonetti-3',
    name: 'Garlic - Simonetti 3',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'hardneck garlic. Cold hardy, produces scapes, complex flavor. Plant in fall for summer harvest.',
    hardinessZones: '3-8',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Simonetti 3'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-skuri-1-3',
    name: 'Garlic - Skuri #1 3',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'softneck garlic. Milder flavor, longer storage, no scapes. Plant in fall for summer harvest.',
    hardinessZones: '5-10',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Skuri #1 3'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-slovak-3',
    name: 'Garlic - Slovak 3',
    scientificName: 'Allium ampeloprasum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 240,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'elephant garlic. Mild giant cloves, closer to leeks. Plant in fall for summer harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'fall',
    height: '3-4 feet',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Slovak 3'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-solent-3',
    name: 'Garlic - Solent 3',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'hardneck garlic. Cold hardy, produces scapes, complex flavor. Plant in fall for summer harvest.',
    hardinessZones: '3-8',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Solent 3'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-sonoran-3',
    name: 'Garlic - Sonoran 3',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'softneck garlic. Milder flavor, longer storage, no scapes. Plant in fall for summer harvest.',
    hardinessZones: '5-10',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Sonoran 3'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-spanish-benitee-3',
    name: 'Garlic - Spanish Benitee 3',
    scientificName: 'Allium ampeloprasum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 240,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'elephant garlic. Mild giant cloves, closer to leeks. Plant in fall for summer harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'fall',
    height: '3-4 feet',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Spanish Benitee 3'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-starbright-3',
    name: 'Garlic - Starbright 3',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'hardneck garlic. Cold hardy, produces scapes, complex flavor. Plant in fall for summer harvest.',
    hardinessZones: '3-8',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Starbright 3'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-susan-delafield-3',
    name: 'Garlic - Susan Delafield 3',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'softneck garlic. Milder flavor, longer storage, no scapes. Plant in fall for summer harvest.',
    hardinessZones: '5-10',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Susan Delafield 3'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-tasmanian-purple-3',
    name: 'Garlic - Tasmanian Purple 3',
    scientificName: 'Allium ampeloprasum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 240,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'elephant garlic. Mild giant cloves, closer to leeks. Plant in fall for summer harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'fall',
    height: '3-4 feet',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Tasmanian Purple 3'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-thermadrone-3',
    name: 'Garlic - Thermadrone 3',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'hardneck garlic. Cold hardy, produces scapes, complex flavor. Plant in fall for summer harvest.',
    hardinessZones: '3-8',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Thermadrone 3'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-tibetan-3',
    name: 'Garlic - Tibetan 3',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'softneck garlic. Milder flavor, longer storage, no scapes. Plant in fall for summer harvest.',
    hardinessZones: '5-10',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Tibetan 3'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-tochliavri-3',
    name: 'Garlic - Tochliavri 3',
    scientificName: 'Allium ampeloprasum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 240,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'elephant garlic. Mild giant cloves, closer to leeks. Plant in fall for summer harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'fall',
    height: '3-4 feet',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Tochliavri 3'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-turban-3',
    name: 'Garlic - Turban 3',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'hardneck garlic. Cold hardy, produces scapes, complex flavor. Plant in fall for summer harvest.',
    hardinessZones: '3-8',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Turban 3'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-ukrainian-3',
    name: 'Garlic - Ukrainian 3',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'softneck garlic. Milder flavor, longer storage, no scapes. Plant in fall for summer harvest.',
    hardinessZones: '5-10',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Ukrainian 3'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-vekak-3',
    name: 'Garlic - Vekak 3',
    scientificName: 'Allium ampeloprasum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 240,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'elephant garlic. Mild giant cloves, closer to leeks. Plant in fall for summer harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'fall',
    height: '3-4 feet',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Vekak 3'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-vietnamese-red-3',
    name: 'Garlic - Vietnamese Red 3',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'hardneck garlic. Cold hardy, produces scapes, complex flavor. Plant in fall for summer harvest.',
    hardinessZones: '3-8',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Vietnamese Red 3'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-vietnamese-purple-3',
    name: 'Garlic - Vietnamese Purple 3',
    scientificName: 'Allium sativum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'softneck garlic. Milder flavor, longer storage, no scapes. Plant in fall for summer harvest.',
    hardinessZones: '5-10',
    plantingSeason: 'fall',
    height: '18-24 inches',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Vietnamese Purple 3'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  },
  {
    id: 'garlic-vostani-3',
    name: 'Garlic - Vostani 3',
    scientificName: 'Allium ampeloprasum',
    category: 'allium',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 0,
    daysToHarvest: 240,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['rose', 'tomato', 'cabbage'],
    enemies: ['bean', 'pea'],
    description: 'elephant garlic. Mild giant cloves, closer to leeks. Plant in fall for summer harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'fall',
    height: '3-4 feet',
    spread: '4-6 inches',
    family: 'Amaryllidaceae',
    varieties: ['Vostani 3'],
    uses: ['cooking', 'roasting', 'medicinal', 'storage']
  }
]
